import React, {
  useState,
  useRef,
  useEffect,
  useMemo,
  useContext,
  useLayoutEffect,
} from "react";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { Button } from "@progress/kendo-react-buttons";
import { CardsPagination } from "../../components/CardsPagination";
import { process } from "@progress/kendo-data-query";
import { useNavigate, Navigate } from "react-router-dom";
import { validators } from "../../utils/validators";
import {
  Users,
  Building2,
  Shield,
  ShieldCheck,
  Eye,
  Search,
  UserPlus,
  LayoutGrid,
  List,
  Filter,
  Power,
  Circle,
  Mail,
  Phone,
  AtSign,
  EyeOff,
  AlertCircle,
  Check,
  MoreVertical,
  UserCheck,
  UserX,
  Edit2,
  Copy,
  Trash2,
  AlertTriangle,
  Activity,
  Key,
} from "lucide-react";
import { systemUsers, organizations } from "../../data/mockData";
import { userApi } from "../../api/userApi";
import { isApiConfigured } from "../../api/axiosClient";
import { LoadingSpinner, ErrorCard } from "../../components/LoadingSpinner";
import { useAuth } from "../../auth/AuthContext";
import LoginActivityCard from "../../components/LoginActivityCard";
import { useToast } from "../../components/Toast";
import { useConfirm } from "../../components/ConfirmDialog";
import { NotificationContext } from "../../contexts/NotificationContext";
import { ValidatedInput } from "../../components/ValidatedInput";
//import { startSignalR,stop } from "../../src/services/signalrService";
import {
  startSignalR,
  stopSignalR,
} from "../../../src/services/signalrService";
import { usePermission } from "../../hooks/usePermission";

/* ── Role → colour map ──────────────────────────────────── */
const ROLE_COLORS = {
  "Super Admin": {
    bg: "#FEE2E2",
    color: "#DC2626",
    ring: "rgba(220,38,38,0.15)",
  },
  Admin: { bg: "#EDE9FE", color: "#7C3AED", ring: "rgba(124,58,237,0.15)" },
  Provider: { bg: "#DBEAFE", color: "#2563EB", ring: "rgba(37,99,235,0.15)" },
  Staff: { bg: "#D1FAE5", color: "#059669", ring: "rgba(5,150,105,0.15)" },
  Viewer: { bg: "#FEF3C7", color: "#D97706", ring: "rgba(217,119,6,0.15)" },
};

const PERMISSION_GROUPS = [
  // =========================================================
  // APPLICATION PAGES
  // =========================================================

  //{
  //  key: "dashboard",
  //  label: "Dashboard",
  //  type: "page",

  //  permissions: [
  //    {
  //      key: "viewDashboard",
  //      label: "View",
  //    },
  //  ],
  //},

  //{
  //  key: "eligibilityAndBenefits",
  //  label: "Eligibility and Benefits",
  //  type: "page",

  //  permissions: [
  //    {
  //      key: "searchMember",
  //      label: "Search Member",
  //    },
  //  ],
  //},

  //{
  //  key: "claimAndPayments",
  //  label: "Claim and Payments",
  //  type: "section",
  //  children: [
  //    {
  //      key: "claimStatus",
  //      label: "Claim Status",

  //      permissions: [
  //        {
  //          key: "searchClaim",
  //          label: "Search Claim",
  //        },
  //        {
  //          key: "requestClaimEop",
  //          label: "Request Claim EOP",
  //        },
  //        {
  //          key: "downloadClaimEop",
  //          label: "Download Claim EOP",
  //          },
  //          {
  //              key: "downloadERA835",
  //              label: "Download ERA(835)",
  //          },
  //      ],
  //    },

  //    {
  //      key: "claimAppeals",
  //      label: "Claim Appeals",
  //      permissions: [
  //        {
  //          key: "viewClaimAppealDetails",
  //          label: "View Claim Appeal Details",
  //          },
  //          {
  //              key: "viewClaimAppealAttachment",
  //              label: "View Claim Appeal Attachment",
  //          },
  //          {
  //              key: "viewClaimAppealStatusHistory",
  //              label: "View Claim Appeal Status History",
  //          },
  //          {
  //              key: "updateClaimAppealStatus",
  //              label: "Update Claim Appeal Status",
  //          },
  //        {
  //          key: "fileClaimAppeal",
  //          label: "File Claim Appeal",
  //        },
  //      ],
  //    },
  //  ],
  //},

  //{
  //  key: "searchEop",
  //  label: "Search EOP",
  //  type: "page",

  //  permissions: [
  //    {
  //      key: "searchEOP",
  //      label: "Search EOP",
  //    },
  //    {
  //      key: "requestEop",
  //      label: "Request EOP",
  //    },
  //    {
  //      key: "downloadEop",
  //      label: "Download EOP",
  //    },
  //    {
  //      key: "downloadERA",
  //      label: "Download ERA (835)",
  //    },
  //  ],
  //},

  // =========================================================
  // SUPER ADMIN
  // =========================================================

  {
    key: "superAdmin",
    label: "Super Admin",
    type: "section",

    children: [
      {
        key: "systemUsers",
        label: "System Users",

        permissions: [
          //{
          //  key: "viewUsers",
          //  label: "View Users",
          //},
          {
            key: "createAdminUser",
            label: "Create Admin User",
          },
          {
            key: "editUser",
            label: "Edit Users",
          },
          {
            key: "deleteUser",
            label: "Delete Users",
          },
          {
            key: "approveProviderAdmin",
            label: "Approve Users(Provider Admin)",
          },
          {
            key: "rejectProviderAdmin",
            label: "Reject Users(Provider Admin)",
          },
          {
            key: "enableDisabled",
            label: "Enable/Disable User",
          },
          {
            key: "viewSignInActivity",
            label: "View Sign In Activity",
          },
          {
            key: "impersonateUser",
            label: "Impersonate User",
          },
        ],
      },

      {
        key: "eftEnrollments",
        label: "EFT Enrollments",
        permissions: [
          {
            key: "viewEnrollmentsDetails",
            label: "View Enrollments Details",
          },
          {
            key: "createEnrollment",
            label: "Create new Enrollment",
          },
          {
            key: "editEnrollment",
            label: "Edit Enrollment",
          },
          {
            key: "viewStatusHistory",
            label: "View Status History",
          },
          {
            key: "updateStatus",
            label: "Change Enrollment Status",
          },
        ],
      },
      {
        key: "eraEnrollments",
        label: "ERA Enrollments",
        permissions: [
          {
            key: "viewEnrollmentsDetails",
            label: "View Enrollments Details",
          },
          {
            key: "createEnrollment",
            label: "Create new Enrollment",
          },
          {
            key: "editEnrollment",
            label: "Edit Enrollment",
          },
          {
            key: "viewStatusHistory",
            label: "View Status History",
          },
          {
            key: "updateStatus",
            label: "Change Enrollment Status",
          },
        ],
      },
      {
        key: "systemSettings",
        label: "System Settings",
        permissions: [
          //{
          //  key: "view",
          //  label: "View System Settings",
          //},
          {
            key: "updateSystemSettings",
            label: "Update System Settings",
          },
        ],
      },

      {
        key: "feedbacks",
        label: "Feedbacks",

        permissions: [
          {
            key: "viewFeedbacks",
            label: "View Feedbacks",
          },
          {
            key: "changeConfig",
            label: "Change Feedback Configuration",
          },
          {
            key: "approveFeedback",
            label: "Approve Feedback",
          },
          {
            key: "hideAndUnhideFeedback",
            label: "Hide/Unhide Feedback",
          },
          {
            key: "feacturedFeedback",
            label: "Featured Feedback",
          },
        ],
      },
    ],
  },
];

const createEmptyPermissions = () => {
  const permissions = {};

  PERMISSION_GROUPS.forEach((group) => {
    // Normal application page
    if (group.type === "page") {
      permissions[group.key] = {};

      group.permissions.forEach((permission) => {
        permissions[group.key][permission.key] = false;
      });

      return;
    }

    // Parent section such as Super Admin
    if (group.type === "section") {
      permissions[group.key] = {};

      group.children.forEach((child) => {
        permissions[group.key][child.key] = {};

        child.permissions.forEach((permission) => {
          permissions[group.key][child.key][permission.key] = false;
        });
      });
    }
  });

  //console.log("createEmptyPermissions : " + JSON.stringify(permissions));

  return permissions;
};

const createAllPermissions = () => {
  const permissions = {};

  PERMISSION_GROUPS.forEach((group) => {
    // Normal application page
    if (group.type === "page") {
      permissions[group.key] = {};

      group.permissions.forEach((permission) => {
        permissions[group.key][permission.key] = true;
      });

      return;
    }

    // Parent section such as Super Admin
    if (group.type === "section") {
      permissions[group.key] = {};

      group.children.forEach((child) => {
        permissions[group.key][child.key] = {};

        child.permissions.forEach((permission) => {
          permissions[group.key][child.key][permission.key] = true;
        });
      });
    }
  });

  //console.log("createAllPermissions : " + JSON.stringify(permissions));

  return permissions;
};

const getSelectedPermissions = (permissions) => {
  const selected = {};

  PERMISSION_GROUPS.forEach((group) => {
    // Normal application page
    if (group.type === "page") {
      const pagePermissions = {};

      group.permissions.forEach((permission) => {
        if (permissions?.[group.key]?.[permission.key] === true) {
          pagePermissions[permission.key] = true;
        }
      });

      if (Object.keys(pagePermissions).length > 0) {
        selected[group.key] = pagePermissions;
      }
    }

    // Section such as Super Admin
    if (group.type === "section") {
      const sectionPermissions = {};

      group.children.forEach((child) => {
        const childPermissions = {};

        child.permissions.forEach((permission) => {
          if (
            permissions?.[group.key]?.[child.key]?.[permission.key] === true
          ) {
            childPermissions[permission.key] = true;
          }
        });

        if (Object.keys(childPermissions).length > 0) {
          sectionPermissions[child.key] = childPermissions;
        }
      });

      if (Object.keys(sectionPermissions).length > 0) {
        selected[group.key] = sectionPermissions;
      }
    }
  });

  return selected;
};

const normalizePermissions = (userPermissions) => {
  const emptyPermissions = createEmptyPermissions();

  if (!userPermissions) {
    return emptyPermissions;
  }

  let parsedPermissions = userPermissions;

  // If API returns permissions as JSON string
  if (typeof userPermissions === "string") {
    try {
      parsedPermissions = JSON.parse(userPermissions);
    } catch (error) {
      console.error("Invalid permissions JSON:", error);
      return emptyPermissions;
    }
  }

  const normalized = createEmptyPermissions();

  PERMISSION_GROUPS.forEach((group) => {
    // Normal page
    if (group.type === "page") {
      group.permissions.forEach((permission) => {
        normalized[group.key][permission.key] =
          parsedPermissions?.[group.key]?.[permission.key] === true;
      });

      return;
    }

    // Section
    if (group.type === "section") {
      group.children.forEach((child) => {
        child.permissions.forEach((permission) => {
          normalized[group.key][child.key][permission.key] =
            parsedPermissions?.[group.key]?.[child.key]?.[permission.key] ===
            true;
        });
      });
    }
  });

  return normalized;
};

/*
 * Supports both:
 *
 * hasPermission(permissions, 'dashboard', 'view')
 *
 * and:
 *
 * hasPermission(
 *     permissions,
 *     'systemUsers',
 *     'approve',
 *     'superAdmin'
 * )
 */
const hasPermission = (permissions, resource, action, section = null) => {
  if (section) {
    return permissions?.[section]?.[resource]?.[action] === true;
  }

  return permissions?.[resource]?.[action] === true;
};

const getPermissionCount = (permissions) => {
  let selected = 0;
  let total = 0;

  PERMISSION_GROUPS.forEach((group) => {
    // Normal page
    if (group.type === "page") {
      group.permissions.forEach((permission) => {
        total++;

        if (permissions?.[group.key]?.[permission.key] === true) {
          selected++;
        }
      });

      return;
    }

    // Section
    if (group.type === "section") {
      group.children.forEach((child) => {
        child.permissions.forEach((permission) => {
          total++;

          if (
            permissions?.[group.key]?.[child.key]?.[permission.key] === true
          ) {
            selected++;
          }
        });
      });
    }
  });

  return {
    selected,
    total,
  };
};

//const relativeDate = (iso) => {
//  if (!iso) return 'Never';
//  const diff = Date.now() - new Date(iso).getTime();
//  const d = Math.floor(diff / 86400000);
//  if (d < 1) return 'today';
//  if (d < 2) return 'yesterday';
//  if (d < 7) return `${d}d ago`;
//  if (d < 30) return `${Math.floor(d / 7)}w ago`;
//  return new Date(iso).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
//};

const relativeDate = (iso) => {
  if (!iso) return "Never";

  const date = new Date(iso);
  const today = new Date();

  // Strip the time portion
  const todayMidnight = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate(),
  );
  const dateMidnight = new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
  );

  const d = Math.round((todayMidnight - dateMidnight) / 86400000);

  if (d === 0) return "today";
  if (d === 1) return "yesterday";
  if (d < 7) return `${d}d ago`;
  if (d < 30) return `${Math.floor(d / 7)}w ago`;

  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
  });
};

/* ── Avatar ─────────────────────────────────────────────── */
const Avatar = ({ firstName = "", lastName = "", role, size = 44 }) => {
  const initials =
    `${firstName.replace(/^Dr\.\s*/, "").charAt(0) || ""}${lastName.charAt(0) || ""}`.toUpperCase() ||
    "?";
  const rc = ROLE_COLORS[role] || { bg: "#F3F4F6", color: "#6B7280" };
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: size * 0.32,
        background: `linear-gradient(135deg, ${rc.color}22, ${rc.color}11)`,
        color: rc.color,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: size * 0.36,
        fontWeight: 700,
        border: `1.5px solid ${rc.ring || rc.bg}`,
        flexShrink: 0,
        letterSpacing: 0.3,
      }}
    >
      {initials}
    </div>
  );
};

/* ── Status pill ─────────────────────────────────────────── */
const StatusPill = ({ status, onClick }) => {
  const active = status === "Active";
  return (
    <span
      onClick={onClick}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        padding: "4px 10px 4px 8px",
        borderRadius: 999,
        fontSize: 12,
        fontWeight: 700,
        background: active ? "rgba(16,185,129,0.1)" : "rgba(156,163,175,0.12)",
        color: active ? "#059669" : "#6B7280",
        border: `1px solid ${active ? "rgba(16,185,129,0.25)" : "rgba(156,163,175,0.25)"}`,
        cursor: onClick ? "pointer" : "default",
        userSelect: "none",
      }}
      title={onClick ? "Click to toggle status" : undefined}
    >
      <Circle size={8} strokeWidth={0} fill={active ? "#10B981" : "#9CA3AF"} />
      {status}
    </span>
  );
};

/* ── Role badge ─────────────────────────────────────────── */
const RoleBadge = ({ role }) => {
  const rc = ROLE_COLORS[role] || { bg: "#F3F4F6", color: "#6B7280" };
  return (
    <span
      style={{
        display: "inline-block",
        padding: "3px 10px",
        borderRadius: 999,
        fontSize: 11,
        fontWeight: 700,
        background: rc.bg,
        color: rc.color,
        letterSpacing: 0.3,
      }}
    >
      {role}
    </span>
  );
};

const MenuItem = ({ icon: Icon, label, onClick, color = "#1A1D21", name }) => (
  <button
    name={name}
    onClick={onClick}
    style={{
      display: "flex",
      alignItems: "center",
      gap: 10,
      width: "100%",
      padding: "9px 12px",
      borderRadius: 8,
      border: "none",
      background: "transparent",
      fontSize: 13,
      fontWeight: 600,
      color,
      cursor: "pointer",
      fontFamily: "inherit",
      textAlign: "left",
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.background = "#F8FAFB";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.background = "transparent";
    }}
  >
    <Icon size={15} strokeWidth={2} />
    {label}
  </button>
);

const capitalize = (str) => {
  const value = str?.trim();
  return value
    ? value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()
    : "";
};

/* ── User Card (system-users variant with Organization + View As) ── */
const SystemUserCard = ({
  user,
  canImpersonate,
  onImpersonate,
  onToggleStatus,
  onApproveUser,
  onEdit,
  onDelete,
  onViewActivity,
  accessPermissions,
}) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const active = user.status === "Active";

  return (
    <div
      style={{
        background: "#fff",
        border: "1px solid #E8ECF0",
        borderRadius: 16,
        padding: 18,
        position: "relative",
        transition: "all 0.2s",
        boxShadow: "0 1px 2px rgba(0,0,0,0.03)",
        opacity: active ? 1 : 0.75,
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.borderColor = "#CBD5E1";
        e.currentTarget.style.boxShadow = "0 4px 16px rgba(0,0,0,0.06)";
        e.currentTarget.style.transform = "translateY(-2px)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.borderColor = "#E8ECF0";
        e.currentTarget.style.boxShadow = "0 1px 2px rgba(0,0,0,0.03)";
        e.currentTarget.style.transform = "translateY(0)";
      }}
    >
      {/* Header: avatar + name + menu */}
      <div
        style={{
          display: "flex",
          gap: 12,
          alignItems: "flex-start",
          marginBottom: 14,
        }}
      >
        <Avatar
          firstName={user.firstName}
          lastName={user.lastName}
          role={user.role}
          size={48}
        />
        <div style={{ flex: 1, minWidth: 0 }}>
          <div
            style={{
              fontSize: 15,
              fontWeight: 700,
              color: "#1A1D21",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {user.firstName} {user.lastName}
          </div>

          <div
            style={{
              marginTop: 4,
              display: "flex",
              gap: 6,
              alignItems: "center",
              flexWrap: "wrap",
            }}
          >
            <RoleBadge role={user.role} />
            {user.isApproved != null &&
            user?.role?.trim().toLowerCase() === "provider admin" &&
            (user.isApproved.trim().toLowerCase() === "pending" ||
              user.isApproved.trim().toLowerCase() === "false") ? (
              <></>
            ) : (
              <>
                {accessPermissions.canEnableDisabled && (
                  <>
                    <StatusPill
                      status={user.status}
                      onClick={() => onToggleStatus(user.id)}
                    />
                  </>
                )}
              </>
            )}
          </div>
        </div>

        <div style={{ position: "relative" }}>
          {user.isApproved != null &&
          user?.role?.trim().toLowerCase() === "provider admin" &&
          (user.isApproved.trim().toLowerCase() === "pending" ||
            user.isApproved.trim().toLowerCase() === "false") ? (
            <></>
          ) : (
            <>
              <button
                name="btnMoreOptionsCard"
                onClick={() => setMenuOpen(!menuOpen)}
                style={{
                  width: 32,
                  height: 32,
                  borderRadius: 8,
                  border: "none",
                  background: menuOpen ? "#F3F4F6" : "transparent",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#6B7280",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = "#F3F4F6";
                }}
                onMouseLeave={(e) => {
                  if (!menuOpen)
                    e.currentTarget.style.background = "transparent";
                }}
                aria-label="More options"
              >
                <MoreVertical size={16} strokeWidth={2} />
              </button>
              {menuOpen && (
                <>
                  <div
                    style={{ position: "fixed", inset: 0, zIndex: 10 }}
                    onClick={() => setMenuOpen(false)}
                  />
                  <div
                    style={{
                      position: "absolute",
                      right: 0,
                      top: 36,
                      zIndex: 11,
                      background: "#fff",
                      border: "1px solid #E8ECF0",
                      borderRadius: 12,
                      boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
                      minWidth: 200,
                      padding: 6,
                    }}
                  >
                    {accessPermissions.canUserImpersonate && canImpersonate && (
                      <>
                        <MenuItem
                          name="btnViewAsUser"
                          icon={Eye}
                          label="View as user"
                          color="#7C3AED"
                          onClick={() => {
                            setMenuOpen(false);
                            onImpersonate(user);
                          }}
                        />
                        <div
                          style={{
                            height: 1,
                            background: "#F1F5F9",
                            margin: "4px 0",
                          }}
                        />
                      </>
                    )}
                    {accessPermissions.canEditUser && (
                      <>
                        <MenuItem
                          icon={Edit2}
                          name="btnEditUser"
                          label="Edit user"
                          onClick={() => {
                            setMenuOpen(false);
                            onEdit(user);
                          }}
                        />
                      </>
                    )}

                    {accessPermissions.canViewSignInActivity && (
                      <>
                        <MenuItem
                          name={"btnViewSignInActivity"}
                          icon={Activity}
                          label="View sign-in activity"
                          onClick={() => {
                            setMenuOpen(false);
                            onViewActivity(user);
                          }}
                        />
                      </>
                    )}

                    {accessPermissions.canDeleteUser && (
                      <>
                        <div
                          style={{
                            height: 1,
                            background: "#F1F5F9",
                            margin: "4px 0",
                          }}
                        />
                        <MenuItem
                          icon={Trash2}
                          label="Delete user"
                          color="#DC2626"
                          onClick={() => {
                            setMenuOpen(false);
                            onDelete(user);
                          }}
                        />
                      </>
                    )}
                    {accessPermissions.canEnableDisabled && (
                      <>
                        <MenuItem
                          name="btnToggleStatus"
                          icon={Power}
                          label={active ? "Deactivate" : "Activate"}
                          color={active ? "#D97706" : "#059669"}
                          onClick={() => {
                            setMenuOpen(false);
                            onToggleStatus(user.id);
                          }}
                        />
                      </>
                    )}
                  </div>
                </>
              )}
            </>
          )}
        </div>
      </div>

      {/* Organization */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8,
          padding: "8px 10px",
          borderRadius: 10,
          background: "rgba(13,148,136,0.06)",
          border: "1px solid rgba(13,148,136,0.12)",
          marginBottom: 12,
        }}
      >
        <Building2 size={14} color="#0D9488" strokeWidth={2} />
        <span
          style={{
            fontSize: 12,
            fontWeight: 700,
            color: "#0F766E",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {user.orgName}
        </span>
      </div>

      {/* Body: contact info */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 8,
          marginBottom: 14,
        }}
      >
        <div style={contactRow}>
          <Mail size={14} color="#9CA3AF" strokeWidth={2} />
          <span
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {user.email || "—"}
          </span>
        </div>
        <div style={contactRow}>
          <Phone size={14} color="#9CA3AF" strokeWidth={2} />
          <span>{user.phone || "—"}</span>
        </div>
      </div>

      {/* Footer: last login + actions */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          paddingTop: 12,
          borderTop: "1px solid #F1F5F9",
          gap: 8,
          flexWrap: "wrap",
        }}
      >
        <div style={{ fontSize: 11, color: "#9CA3AF" }}>
          Registered On :{" "}
          <strong style={{ color: "#6B7280" }}>
            {user.registerDate || "—"}
          </strong>
        </div>

        {user.isApproved === "true" && user.approvedBy && (
          <div style={{ fontSize: 11, color: "#9CA3AF", marginTop: 4 }}>
            Approved By :{" "}
            <strong style={{ color: "#16A34A" }}>{user.approvedBy}</strong>
          </div>
        )}

        {user.isApproved === "false" && user.rejectedBy && (
          <div style={{ fontSize: 11, color: "#9CA3AF", marginTop: 4 }}>
            Rejected By :{" "}
            <strong style={{ color: "#DC2626" }}>{user.rejectedBy}</strong>
          </div>
        )}
        {user?.role?.trim().toLowerCase() === "provider admin" && (
          <div style={{ fontSize: 11, color: "#9CA3AF" }}>
            Tax Id : <strong style={{ color: "#6B7280" }}>{user.taxIds}</strong>
          </div>
        )}
        {user.isApproved != null &&
        user?.role?.trim().toLowerCase() === "provider admin" &&
        user.isApproved.trim().toLowerCase() === "pending" ? (
          <></>
        ) : (
          <>
            <div style={{ fontSize: 11, color: "#9CA3AF" }}>
              Last seen{" "}
              <strong style={{ color: "#6B7280" }}>
                {relativeDate(user.lastLogin)}
              </strong>
            </div>
          </>
        )}
        <div style={{ fontSize: 11, color: "#9CA3AF" }}>
          {user.isDisabledDueToInactivity && (
            <strong style={{ color: "#EF4444" }}>
              User Disabled (Inactive) due to prolonged inactivity.
            </strong>
          )}
        </div>
        <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
          {user.isApproved != null &&
          user?.role?.trim().toLowerCase() === "provider admin" &&
          user.isApproved.trim().toLowerCase() === "pending" ? (
            <>
              {accessPermissions.canApproveProviderAdmin && (
                <>
                  <button
                    name="btnApproveUserCard"
                    id={`btnApproveUserCard${user.id}`}
                    onClick={async () => await onApproveUser(user.id, true)}
                    title={`Approve ${user.firstName} ${user.lastName}`}
                    style={{
                      padding: "5px 10px",
                      borderRadius: 8,
                      border: "none",
                      background: "linear-gradient(135deg, #22C55E, #16A34A)",
                      color: "#fff",
                      fontSize: 12,
                      fontWeight: 700,
                      cursor: "pointer",
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 4,
                      fontFamily: "inherit",
                      boxShadow: "0 2px 6px rgba(139,92,246,0.3)",
                    }}
                  >
                    <UserCheck size={12} strokeWidth={2.5} />
                    Approve
                  </button>
                </>
              )}
              {accessPermissions.canRejectProviderAdmin && (
                <>
                  <button
                    name="btnRejectUserCard"
                    id={`btnRejectUserCard${user.id}`}
                    onClick={async () => await onApproveUser(user.id, false)}
                    title={`Reject ${user.firstName} ${user.lastName}`}
                    style={{
                      padding: "5px 10px",
                      borderRadius: 8,
                      border: "none",
                      marginLeft: "5px",
                      background: "linear-gradient(135deg, #EF4444, #DC2626)",
                      color: "#fff",
                      fontSize: 12,
                      fontWeight: 700,
                      cursor: "pointer",
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 4,
                      fontFamily: "inherit",
                      boxShadow: "0 2px 6px rgba(139,92,246,0.3)",
                    }}
                  >
                    <UserX size={12} strokeWidth={2.5} />
                    Reject
                  </button>
                </>
              )}
            </>
          ) : (
            <>
              {user.isApproved != null &&
              user?.role?.trim().toLowerCase() === "provider admin" &&
              (user.isApproved.trim().toLowerCase() === "pending" ||
                user.isApproved.trim().toLowerCase() === "false") ? (
                <></>
              ) : (
                <>
                  {accessPermissions.canEnableDisabled && (
                    <>
                      <button
                        name="btnToggleStatusCardFooter"
                        onClick={() => onToggleStatus(user.id)}
                        style={{
                          padding: "6px 12px",
                          borderRadius: 8,
                          border: `1px solid ${active ? "rgba(217,119,6,0.25)" : "rgba(5,150,105,0.25)"}`,
                          background: active
                            ? "rgba(245,158,11,0.08)"
                            : "rgba(16,185,129,0.08)",
                          color: active ? "#D97706" : "#059669",
                          fontSize: 12,
                          fontWeight: 700,
                          cursor: "pointer",
                          display: "inline-flex",
                          alignItems: "center",
                          gap: 5,
                          fontFamily: "inherit",
                        }}
                      >
                        <Power size={12} strokeWidth={2.5} />
                        {active ? "Deactivate" : "Activate"}
                      </button>
                    </>
                  )}
                </>
              )}
              {accessPermissions.canEditUser && (
                <>
                  <button
                    name="btnEditCardFooter"
                    onClick={() => onEdit(user)}
                    title="Edit user"
                    style={cardIconBtn("#0D9488")}
                  >
                    <Edit2 size={13} strokeWidth={2.5} />
                  </button>
                </>
              )}

              {accessPermissions.canDeleteUser && (
                <>
                  <button
                    name="btnDeleteCardFooter"
                    onClick={() => onDelete(user)}
                    title="Delete user"
                    style={cardIconBtn("#DC2626")}
                  >
                    <Trash2 size={13} strokeWidth={2.5} />
                  </button>
                </>
              )}

              {accessPermissions.canUserImpersonate && (
                <>
                  {canImpersonate && (
                    <button
                      name="btnImpersonateCardFooter"
                      onClick={() => onImpersonate(user)}
                      style={{
                        padding: "6px 12px",
                        borderRadius: 8,
                        border: "none",
                        background: "linear-gradient(135deg, #8B5CF6, #7C3AED)",
                        color: "#fff",
                        fontSize: 12,
                        fontWeight: 700,
                        cursor: "pointer",
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 5,
                        fontFamily: "inherit",
                        boxShadow: "0 2px 6px rgba(139,92,246,0.3)",
                      }}
                      title={`View portal as ${user.firstName} ${user.lastName}`}
                    >
                      <Eye size={12} strokeWidth={2.5} />
                      View As
                    </button>
                  )}
                </>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

const cardIconBtn = (color) => ({
  width: 30,
  height: 30,
  borderRadius: 8,
  border: `1px solid ${color}33`,
  background: `${color}0A`,
  color,
  cursor: "pointer",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  padding: 0,
});

const contactRow = {
  display: "flex",
  alignItems: "center",
  gap: 8,
  fontSize: 13,
  color: "#6B7280",
};

/* ──────────────────────────────────────────────────────────────────── */
/* Main component                                                      */
/* ──────────────────────────────────────────────────────────────────── */
const SystemUsersPage = () => {
  const { refreshNotifications } = useContext(NotificationContext);

  const navigate = useNavigate();
  const toast = useToast();
  const confirm = useConfirm();
  const { can, canAny, canAll } = usePermission();

  const [revealPassword, setRevealPassword] = useState(false);

  const { user: currentUser, impersonate, isImpersonating } = useAuth();

  const [accessPermissions, setAccessPermissions] = useState({});

  const [viewportWidth, setViewportWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 1024,
  );

  /***********************Access Permissions ******************************/

  useEffect(() => {
    setAccessPermissions({
      canEditUser: can("superAdmin", "systemUsers", "editUser"),
      canDeleteUser: can("superAdmin", "systemUsers", "deleteUser"),
      canCreateAdminUser: can("superAdmin", "systemUsers", "createAdminUser"),
      canApproveProviderAdmin: can(
        "superAdmin",
        "systemUsers",
        "approveProviderAdmin",
      ),
      canRejectProviderAdmin: can(
        "superAdmin",
        "systemUsers",
        "rejectProviderAdmin",
      ),
      canEnableDisabled: can("superAdmin", "systemUsers", "enableDisabled"),
      canViewSignInActivity: can(
        "superAdmin",
        "systemUsers",
        "viewSignInActivity",
      ),
      canUserImpersonate: can("superAdmin", "systemUsers", "impersonateUser"),
    });
  }, [currentUser]);

  /***********************Access Permissions ******************************/

  useLayoutEffect(() => {
    if (typeof window === "undefined") return;
    const onResize = () => setViewportWidth(window.innerWidth);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);
  const [dataState, setDataState] = useState({
    skip: 0,
    take: 10,
    sort: [],
    filter: null,
  });

  const [users, setUsers] = useState([]);
  const [countsData, setCountsData] = useState({});
  const [totalRecords, setTotalRecords] = useState(0);
  const [gridLoading, setGridLoading] = useState(false);
  //const [orgs] = useState(organizations);
  const [orgs, setOrgs] = useState([]);
  const [roles, setRoles] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [searchInputText, setSearchInputText] = useState("");
  const [multiSearchText, setMultiSearchText] = useState({
    organization: "",
    role: "",
    status: "",
    proAdminApproveStatus: "",
  });
  const searchTimeoutRef = useRef(null);
  const [filterOrg, setFilterOrg] = useState("All");
  const [filterRole, setFilterRole] = useState("All");
  const [filterStatus, setFilterStatus] = useState("All");
  const [filterProAdminApproveStatus, setFilterProAdminApproveStatus] =
    useState("All");
  const [viewMode, setViewMode] = useState("cards"); // 'cards' | 'table'
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [pageLoading, setPageLoading] = useState(false);

  const [showDialog, setShowDialog] = useState(false);
  const [editingUser2, setEditingUser2] = useState(null);

  // Edit / Delete / Activity dialog state
  const [editingUser, setEditingUser] = useState(null);
  const [showEditDialog, setShowEditDialog] = useState(false);
  const [saving, setSaving] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [deleting, setDeleting] = useState(false);
  const [activityUser, setActivityUser] = useState(null);

  // Super Admin guard
  if (
    currentUser?.userRole?.trim().toLowerCase() !== "super admin" &&
    currentUser?.userRole?.trim().toLowerCase() !== "admin"
  ) {
    return <Navigate to="/" replace />;
  }

  const styles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      background: "rgba(255,255,255,0.7)",
      zIndex: 9999,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    gridOverlay: {
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: "rgba(255,255,255,0.6)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000,
    },
  };

  const formatDate = (value) => {
    if (!value) return "--";

    // Replace - with /
    const normalized = value.replace(/-/g, "/");
    return normalized;
  };
  const formatters = {
    /* Format phone as (XXX) XXX-XXXX */
    phone: (value) => {
      if (!value) return "";
      const digits = value.replace(/\D/g, "").slice(0, 10);
      if (digits.length < 4) return digits;
      if (digits.length < 7)
        return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
      return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
    },
  };

  const formatSearchText = (text) => {
    const regex = /^\d{2}\/\d{2}\/\d{4}$/;

    if (!regex.test(text)) {
      return text;
    }

    const [month, day, year] = text.split("/");
    return `${year}-${month}-${day}`;
  };
  const run = async (customState = dataState, customSearch = searchText) => {
    setLoading(true);
    try {
      const sort = customState.sort?.[0];

      const res = await userApi.getSystemUsers({
        searchText: customSearch || "",
        sortColumnName: sort?.field || "",
        sortColumnDirection: sort?.dir || "",
        startIndex: customState.skip || 0,
        pageSize: customState.take || 10,
      });

      const formattedUsers = res.data.Data.map((u) => ({
        id: u.Id,
        userName: u.Username,
        firstName: capitalize(u.Firstname) || "",
        lastName: capitalize(u.Lastname) || "",
        lastLogin: u.LastLogin || "",
        email: u.Email || "",
        phone: formatters.phone(u.Attributes?.phone?.[0]) || "N/A",
        role: u.Attributes?.userRole?.[0] || "N/A",
        //orgName: u.Attributes?.orgName?.[0] || 'N/A',
        orgName: u.Attributes?.orgName?.[0]?.trim()
          ? u.Attributes.orgName[0].toUpperCase()
          : "N/A",
        parentUserId: u.Attributes?.parentUserId?.[0] || "N/A",
        //  taxId: u.Attributes?.TaxID?.[0] || '',
        orgPhone: u.Attributes?.orgPhone?.[0] || "N/A",
        //isApproved: u.Attributes?.isApproved?.[0] != null
        //    ? u.Attributes.isApproved[0] === "true"
        //    : null,
        isApproved: u.Attributes?.isApproved?.[0]?.trim().toLowerCase() ?? null,
        approvedBy: u.Attributes?.approvedBy?.[0]?.trim() ?? null,
        rejectedBy: u.Attributes?.rejectedBy?.[0]?.trim() ?? null,
        taxIds: u.Attributes?.TaxID?.join(", ") || "N/A",

        status: u.Enabled ? "Active" : "Inactive",
        isDisabledDueToInactivity:
          u.Attributes?.isDisabledDueToInactivity?.[0]?.trim().toLowerCase() ===
          "true",

        userFullName: `${u.Firstname || ""} ${u.Lastname || ""}`.trim(),
        registerDate: formatDate(u.CreatedAt),
        permissions: u?.Attributes?.userPermissions
          ? JSON.parse(u?.Attributes?.userPermissions)
          : null,
      }));

      setUsers(formattedUsers);

      setTotalRecords(res?.data?.TotalRecords || 0);
      setCountsData(res?.data?.CountData || {});

      const resOrg = await userApi.getOrganizations();
      setOrgs(resOrg.data);

      const resRoles = await userApi.getUserRoles();
      setRoles(resRoles.data);

      //  alert("SET UP ROLES :"+JSON.stringify(roles));
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.message || "Failed to load system users");
    } finally {
      setLoading(false);
    }
  };
  const normalizeSearchDate = (search) => {
    if (/^(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01])\/\d{4}$/.test(search)) {
      return search.replaceAll("/", "-");
    }
    return search;
  };

  const run2 = async (customState = dataState, customSearch = searchText) => {
    // alert(JSON.stringify(customSearch));
    //return;

    setGridLoading(true);
    try {
      const sort = customState.sort?.[0];

      //console.log("---------------------------------");
      //console.log("sortColumnName : " + sort?.field);
      //console.log("sortColumnDirection : " + sort?.dir);
      //console.log("startIndex : " + customState.skip);
      //console.log("pageSize : " + customState.take);
      //console.log("---------------------------------");

      const res = await userApi.getSystemUsers({
        searchText: customSearch || "",
        sortColumnName: sort?.field || "",
        sortColumnDirection: sort?.dir || "",
        startIndex: customState.skip || 0,
        pageSize: customState.take || 10,
      });

      const formattedUsers = res?.data?.Data?.map((u) => ({
        id: u.Id,
        userName: u.Username,
        firstName: capitalize(u.Firstname) || "",
        lastName: capitalize(u.Lastname) || "",
        lastLogin: u.LastLogin || "",
        email: u.Email || "",
        phone: formatters.phone(u.Attributes?.phone?.[0]) || "N/A",
        role: u.Attributes?.userRole?.[0] || "N/A",
        //orgName: u.Attributes?.orgName?.[0] || 'N/A',
        orgName: u.Attributes?.orgName?.[0]?.trim()
          ? u.Attributes.orgName[0].toUpperCase()
          : "N/A",
        parentUserId: u.Attributes?.parentUserId?.[0] || "N/A",
        //  taxId: u.Attributes?.TaxID?.[0] || 'N/A',
        orgPhone: u.Attributes?.orgPhone?.[0] || "N/A",
        //isApproved: u.Attributes?.isApproved?.[0] != null
        //    ? u.Attributes.isApproved[0] === "true"
        //    : null,
        isApproved: u.Attributes?.isApproved?.[0]?.trim().toLowerCase() ?? null,
        approvedBy: u.Attributes?.approvedBy?.[0]?.trim() ?? null,
        rejectedBy: u.Attributes?.rejectedBy?.[0]?.trim() ?? null,
        taxIds: u.Attributes?.TaxID?.join(", ") || "N/A",

        status: u.Enabled ? "Active" : "Inactive",
        userFullName: `${u.Firstname || ""} ${u.Lastname || ""}`.trim(),
        registerDate: formatDate(u.CreatedAt),
      }));

      setUsers(formattedUsers || []);
      setTotalRecords(res?.data?.TotalRecords || 0);
      setCountsData(res?.data?.CountData || {});

      setGridLoading(false);

      //  alert("SET UP ROLES :"+JSON.stringify(roles));
    } catch (err) {
      setError(err.response?.data?.message || "Failed to load system users");
      setGridLoading(false);
    } finally {
      setGridLoading(false);
    }
  };

  useEffect(() => {
    if (isApiConfigured()) {
      run(dataState);
    }
  }, []);

  const emptyUser = {
    userName: "",
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    password: "",
    confirmPassword: "",
    role: "",
    status: "Active",
  };

  /* ── Username validation ────────────────────────────────
   * Rules:
   *   - required
   *   - 3-30 chars
   *   - lowercase letters, digits, and .  _  - only
   *   - must start with a letter
   *   - uniqueness checked against existing users (case-insensitive),
   *     excluding the currently-edited user (by id) so that editing
   *     without changing the username is allowed.
   *
   * Returns { valid: boolean, reason: string | null }
   */
  const USERNAME_PATTERN = /^[a-z][a-z0-9._-]{2,29}$/;
  const EMAIL_PATTERN =
    /^[a-z0-9][a-z0-9._+-]*@[a-z0-9][a-z0-9.-]*\.[a-z]{2,}$/;

  /**
   * A username may be either:
   *   (a) a traditional handle  — 3-30 chars, starts with a letter,
   *       lowercase letters / digits / . _ - only
   *   (b) a full email address  — e.g. jane@clinic.com
   * In both cases the value must be unique across users (case-insensitive).
   */
  const validateUsername = (raw, allUsers, currentUserId) => {
    const username = (raw || "").trim().toLowerCase();
    if (!username) return { valid: false, reason: "Username is required." };
    if (username.length < 3)
      return { valid: false, reason: "Must be at least 3 characters." };
    if (username.length > 254)
      return { valid: false, reason: "Must be 254 characters or fewer." };

    const isEmail = username.includes("@");
    if (isEmail) {
      if (!EMAIL_PATTERN.test(username)) {
        return {
          valid: false,
          reason: "Enter a valid email address (e.g. jane@clinic.com).",
        };
      }
    } else {
      if (username.length > 30) {
        return {
          valid: false,
          reason:
            "Username must be 30 characters or fewer (or use a full email).",
        };
      }
      if (!USERNAME_PATTERN.test(username)) {
        return {
          valid: false,
          reason:
            "Use lowercase letters, digits, and . _ - only. Must start with a letter — or enter a full email address.",
        };
      }
    }

    const clash = allUsers.some(
      (u) =>
        u.id !== currentUserId && (u.userName || "").toLowerCase() === username,
    );
    // if (clash) return { valid: false, reason: 'This username is already taken. Please choose another.' };
    return { valid: true, reason: null };
  };

  /**
   * Cryptographically-secure password generator.
   * Produces a 14-character password guaranteed to contain at least one
   * uppercase letter, one lowercase letter, one digit, and one symbol.
   * Excludes visually-ambiguous characters (I, l, 1, O, 0) to reduce
   * copy/paste errors when sharing the password with a new user.
   */
  const generatePassword = (length = 14) => {
    const upper = "ABCDEFGHJKLMNPQRSTUVWXYZ";
    const lower = "abcdefghjkmnpqrstuvwxyz";
    const digits = "23456789";
    const symbols = "!@#$%^&*-_+=?";
    const all = upper + lower + digits + symbols;

    const randomInt = (max) => {
      const buf = new Uint32Array(1);
      (window.crypto || window.msCrypto).getRandomValues(buf);
      return buf[0] % max;
    };

    // Guarantee at least one char from each category.
    const chars = [
      upper[randomInt(upper.length)],
      lower[randomInt(lower.length)],
      digits[randomInt(digits.length)],
      symbols[randomInt(symbols.length)],
    ];
    while (chars.length < length) {
      chars.push(all[randomInt(all.length)]);
    }
    // Fisher-Yates shuffle so the guaranteed chars aren't always at the start.
    for (let i = chars.length - 1; i > 0; i--) {
      const j = randomInt(i + 1);
      [chars[i], chars[j]] = [chars[j], chars[i]];
    }
    return chars.join("");
  };

  const suggestUsername = (
    firstName = "",
    lastName = "",
    takenSet = new Set(),
  ) => {
    const clean = (s) =>
      s
        .replace(/^Dr\.\s*/i, "")
        .toLowerCase()
        .replace(/[^a-z0-9]/g, "");
    const first = clean(firstName);
    const last = clean(lastName);
    if (!first && !last) return "";
    const base = (first.charAt(0) + last).slice(0, 20) || first.slice(0, 20);
    let candidate = base;
    let i = 1;
    while (takenSet.has(candidate)) {
      candidate = `${base}${i}`;
      i += 1;
      if (i > 99) break; // safety
    }
    return candidate;
  };
  /* Actions */
  const openAddDialog = () => {
    setEditingUser2({ ...emptyUser, id: null });
    //setRevealPassword(false);
    setShowDialog(true);
  };

  const closeDialog = () => {
    setShowDialog(false);
    setEditingUser2(null);
    //setRevealPassword(false);
  };
  /* Derived ─ filtered list & stats */
  //const filteredUsers = useMemo(() => {
  //  const q = searchText.trim().toLowerCase();
  //  return users.filter((u) => {
  //    if (q && !(
  //        `${u.firstName} ${u.lastName}`.toLowerCase().includes(q) ||
  //      u.email.toLowerCase().includes(q) ||
  //        (u.orgName || '').toLowerCase().includes(q)
  //    )) return false;
  //      if (filterOrg !== 'All' && u.orgName !== filterOrg) return false;
  //    if (filterRole !== 'All' && u.role !== filterRole) return false;
  //    if (filterStatus !== 'All' && u.status !== filterStatus) return false;
  //    return true;
  //  });
  //}, [users, searchText, filterOrg, filterRole, filterStatus]);

  // Reset to page 0 when any filter changes — avoids landing on an empty
  // page after the result set shrinks.
  useEffect(() => {
    setDataState((s) => ({ ...s, skip: 0 }));
  }, [searchText, filterOrg, filterRole, filterStatus]);

  // Pre-process: drives both Cards and Table paging/sorting from one source.
  //  const gridData = process(filteredUsers, dataState);

  const gridData = {
    data: users,
    total: totalRecords,
  };

  const stats = useMemo(
    () => ({
      total: countsData?.TotalUsers || 0,
      orgs: orgs?.length || 0,
      //superAdmins: users.filter(u => u.role === 'Super Admin' && u.status === 'Active').length,
      superAdmins: countsData?.TotalSuperAdminUsers || 0,
      active: countsData?.TotalActiveUsers || 0,
      inactive: countsData?.TotalInactiveUsers || 0,
    }),
    [countsData, orgs],
  );

  const updateField = (field, value) => {
    setEditingUser2((prev) => ({ ...prev, [field]: value }));
    setError("");
  };

  /* Actions */
  const handleImpersonate = async (targetUser) => {
    //alert(JSON.stringify(targetUser));
    const ok = await impersonate(targetUser);

    if (ok) {
      navigate("/");

      toast.info(
        `Now viewing as ${targetUser.firstName} ${targetUser.lastName}.`,
        { title: "Impersonation started" },
      );
      // await refreshNotifications();
    } else {
      setPageLoading(false);
      toast.error("Unable to impersonate this user.", {
        title: "Impersonation failed",
      });
    }
  };

  const canImpersonateUser = (u) =>
    !isImpersonating &&
    u?.role !== "Super Admin" &&
    u?.id !== currentUser?.id &&
    u?.status === "Active" &&
    (u?.isApproved?.trim().toLowerCase() === "true" || u?.isApproved == null); //for provider admin user

  /* ── Edit ─────────────────────────────────────────── */
  const openEditDialog = (user) => {
    //alert(JSON.stringify(user));
    setEditingUser({ ...user });
    setShowEditDialog(true);
  };

  const handleSaveEdit = async () => {
    if (!editingUser) return;
    if (!editingUser.firstName || !editingUser.lastName || !editingUser.email) {
      toast.error("First Name, Last Name, and Email are required.", {
        title: "Missing information",
      });
      return;
    }
    // Keep organizationName in sync with organizationId if it changed
    const orgMatch = orgs.find((o) => o.id === editingUser.orgName);
    const patched = {
      ...editingUser,
      orgName: orgMatch ? orgMatch.name : editingUser.orgName,
    };
    const displayName = `${patched.firstName} ${patched.lastName}`;

    if (isApiConfigured()) {
      setSaving(true);
      try {
        const selectedPermissions = getSelectedPermissions(
          editingUser.permissions,
        );
        //console.log(
        //    "Selected Permissions:",
        //    JSON.stringify(selectedPermissions, null, 2),
        //);

        const updatedPatched = {
          ...patched,
          selectedPermissions: selectedPermissions,
        };

        const res = await userApi.updateUser(updatedPatched);
        if (res.success) {
          setUsers(users.map((u) => (u.id === patched.id ? patched : u)));
          setShowEditDialog(false);
          setEditingUser(null);

          toast.success(`${displayName} was updated at ${patched.orgName}.`, {
            title: "User updated",
          });
        } else {
          toast.error(`${displayName} was not updated.`, {
            title: "Error in Update",
          });
        }
      } catch (err) {
        toast.error(err.message || "Failed to save user", {
          title: "Update failed",
        });
      } finally {
        setSaving(false);
      }
    } else {
      setUsers(users.map((u) => (u.id === patched.id ? patched : u)));
      setShowEditDialog(false);
      setEditingUser(null);
      toast.success(`${displayName} was updated at ${patched.orgName}.`, {
        title: "User updated",
      });
    }
  };

  /* ── Delete ───────────────────────────────────────── */
  const openDeleteDialog = (user) => {
    // Safety: block deletion of self and of the last Super Admin in the system

    if (user.id === currentUser?.userId) {
      toast.warning("You cannot delete your own account.", {
        title: "Action blocked",
      });
      return;
    }
    const activeSuperAdmins = users.filter(
      (u) => u.role === "Super Admin" && u.status === "Active",
    );
    if (user.role === "Super Admin" && activeSuperAdmins.length <= 1) {
      toast.warning(
        "Cannot delete the last active Super Admin in the system.",
        { title: "Action blocked" },
      );
      return;
    }
    setDeleteTarget(user);
  };

  const handleConfirmDelete = async () => {
    if (!deleteTarget) return;
    const displayName = `${deleteTarget.firstName} ${deleteTarget.lastName}`;
    const orgName = deleteTarget.orgName;
    if (isApiConfigured()) {
      setDeleting(true);
      try {
        setPageLoading(true);
        const res = await userApi.deleteUser({ UserId: deleteTarget.id });
        if (res.success) {
          //setUsers(users.filter(u => u.id !== deleteTarget.id));

          const updatedUsers = users.filter((u) => u.id !== deleteTarget.id);

          setUsers(updatedUsers);
          setTotalRecords(updatedUsers.length);

          //set counts data
          setCountsData((prev) => ({
            ...prev,
            TotalUsers: prev.TotalUsers - 1,
            TotalActiveUsers:
              deleteTarget.status === "Active"
                ? prev.TotalActiveUsers - 1
                : prev.TotalActiveUsers,
            TotalInactiveUsers:
              deleteTarget.status === "Inactive"
                ? prev.TotalInactiveUsers - 1
                : prev.TotalInactiveUsers,
            TotalSuperAdminUsers:
              deleteTarget.role === "Super Admin"
                ? prev.TotalSuperAdminUsers - 1
                : prev.TotalSuperAdminUsers,
          }));

          // await run2(dataState, searchText);
          setDeleteTarget(null);
          toast.success(`${displayName} was deleted from ${orgName}.`, {
            title: "User Deleted",
          });
        } else {
          toast.error("Failed to delete user", { title: "Delete failed" });
        }
        setPageLoading(false);
      } catch (err) {
        setPageLoading(false);
        toast.error(err.message || "Failed to delete user", {
          title: "Delete failed",
        });
      } finally {
        setPageLoading(false);
        setDeleting(false);
      }
    } else {
      setUsers(users.filter((u) => u.id !== deleteTarget.id));
      setDeleteTarget(null);
      toast.success(`${displayName} was removed from ${orgName}.`, {
        title: "User deleted",
      });
    }
  };

  /* ── UsernameField: input with live availability check ───────── */
  const UsernameField = ({
    value,
    onChange,
    allUsers,
    currentUserId,
    readOnly,
  }) => {
    const { valid, reason } = validateUsername(value, allUsers, currentUserId);
    const isEmpty = !value || !value.trim();
    // Only show validation state after the user has typed something
    const showValid = !isEmpty && valid;
    const showError = !isEmpty && !valid;

    const borderColor = readOnly
      ? "#E8ECF0"
      : showValid
        ? "#059669"
        : showError
          ? "#DC2626"
          : "#E8ECF0";

    return (
      <>
        <div
          style={{
            position: "relative",
            display: "flex",
            alignItems: "center",
            border: `1.5px solid ${borderColor}`,
            borderRadius: 10,
            background: readOnly ? "#F3F4F6" : "#F8FAFB",
            transition: "all 0.15s",
          }}
        >
          <AtSign
            size={15}
            color="#9CA3AF"
            strokeWidth={2}
            style={{ position: "absolute", left: 12 }}
          />
          <input
            type="text"
            value={value}
            readOnly={readOnly}
            onChange={(e) => {
              if (readOnly) return;
              // Allow characters for both a traditional username (a-z 0-9 . _ -)
              // and an email address (adds @ and +). Keep lowercase throughout.
              const cleaned = e.target.value
                .toLowerCase()
                .replace(/[^a-z0-9._+@-]/g, "");
              onChange(cleaned.slice(0, 254));
            }}
            placeholder="Choose a unique username or email"
            style={{
              flex: 1,
              minWidth: 0,
              padding: "10px 40px 10px 36px",
              border: "none",
              background: "transparent",
              fontSize: 14,
              fontFamily: "inherit",
              outline: "none",
              color: readOnly ? "#6B7280" : "#1A1D21",
              cursor: readOnly ? "not-allowed" : "text",
            }}
            autoComplete="off"
            autoCapitalize="off"
            autoCorrect="off"
            spellCheck="false"
          />
          {!readOnly && showValid && (
            <Check
              size={16}
              color="#059669"
              strokeWidth={2.5}
              style={{ position: "absolute", right: 14 }}
            />
          )}
          {!readOnly && showError && (
            <AlertCircle
              size={16}
              color="#DC2626"
              strokeWidth={2.5}
              style={{ position: "absolute", right: 14 }}
            />
          )}
        </div>
        {/* Helper / validation text */}
        <div
          style={{
            marginTop: 6,
            fontSize: 12,
            fontWeight: 500,
            color: readOnly
              ? "#9CA3AF"
              : showValid
                ? "#059669"
                : showError
                  ? "#DC2626"
                  : "#6B7280",
            display: "flex",
            alignItems: "center",
            gap: 5,
          }}
        >
          {readOnly
            ? "Usernames cannot be changed after account creation."
            : isEmpty
              ? "Enter a username (letters, digits, . _ -) or an email address."
              : showValid
                ? //? <>{value} is available</>
                  ""
                : reason}
          {/*}*/}
        </div>
      </>
    );
  };

  const approveUser = async (userId, approveStatus) => {
    const u = users.find((x) => x.id === userId);

    const nextStatus = approveStatus;

    if (!u) return;
    const next = approveStatus;

    const ok = await confirm({
      title: `${next === true ? "Approve" : "Reject"} ${u.firstName} ${u.lastName}?`,
      message: `${u.orgName} · ${u.role}. ${
        next === true
          ? `${u.firstName} will gain access to the portal.`
          : `${u.firstName} will be rejected.`
      }`,
      confirmLabel: next === true ? "Approve" : "Reject",
      variant: next === true ? "approve" : "reject",
    });
    if (!ok) return;
    const displayName = `${u.firstName} ${u.lastName}`;

    let rejectReason = "";

    if (!nextStatus) {
      rejectReason = ok.reason;
    }

    if (isApiConfigured()) {
      setPageLoading(true);
      userApi
        .approveUser({
          userId: userId,
          currentapproveStatus: nextStatus,
          rejectReason: rejectReason,
        })
        .then(async (res) => {
          setPageLoading(false);

          if (res.success) {
            toast.success(
              `${displayName} is now ${next ? "Approved" : "Rejected"}`,
              {
                title: next ? "User approved" : "User rejected",
              },
            );

            setUsers(users.map((x) => (x.id === userId ? res.data : x)));
            setUsers(
              users.map((x) =>
                x.id === userId
                  ? { ...x, isApproved: nextStatus.toString() }
                  : x,
              ),
            );
          } else {
            toast.warning(res.message, {
              title: "User Approved",
            });
          }
        })
        .catch((err) => {
          console.error(err);
          setPageLoading(false);
          toast.error(err.message || "Failed to approve user", {
            title: "Approve failed",
          });
        });
      //.catch((err) => toast.error(err.message || 'Failed to toggle status', { title: 'Status change failed' }));
    } else {
      setUsers(
        users.map((x) => (x.id === userId ? { ...x, isApproved: next } : x)),
      );
      toast.success(`${displayName} is now ${next}.`, {
        title: next === "Active" ? "User Approved" : "User Disapproved",
      });
    }
  };

  const toggleStatus = async (userId) => {
    const u = users.find((x) => x.id === userId);
    const nextStatus = u.status === "Active" ? "Inactive" : "Active";
    if (!u) return;
    const next = u.status === "Active" ? "Inactive" : "Active";
    const ok = await confirm({
      title: `${next === "Active" ? "Activate" : "Deactivate"} ${u.firstName} ${u.lastName}?`,
      message: `${u.orgName} · ${u.role}. ${
        next === "Active"
          ? `${u.firstName} will regain access to the portal.`
          : `${u.firstName} will lose access until reactivated.`
      }`,
      confirmLabel: next === "Active" ? "Activate" : "Deactivate",
      variant: next === "Active" ? "info" : "warning",
    });
    if (!ok) return;
    const displayName = `${u.firstName} ${u.lastName}`;

    if (isApiConfigured()) {
      setPageLoading(true);
      userApi
        .toggleStatus({
          userId: userId,
          userStatus: u.status,
        })
        .then(async (res) => {
          setUsers(users.map((x) => (x.id === userId ? res.data : x)));
          setUsers(
            users.map((x) =>
              x.id === userId
                ? { ...x, status: nextStatus, isDisabledDueToInactivity: false }
                : x,
            ),
          );

          setCountsData((prev) => ({
            ...prev,
            TotalActiveUsers:
              nextStatus === "Active"
                ? prev.TotalActiveUsers + 1
                : prev.TotalActiveUsers - 1,

            TotalInactiveUsers:
              nextStatus === "Inactive"
                ? prev.TotalInactiveUsers + 1
                : prev.TotalInactiveUsers - 1,
          }));

          // await run2(dataState, searchText);
          setPageLoading(false);
          toast.success(`${displayName} is now ${next}.`, {
            title: next === "Active" ? "User activated" : "User deactivated",
          });
        })
        .catch((err) => {
          console.error(err);
          setPageLoading(false);
          toast.error(err.message || "Failed to toggle status", {
            title: "Status change failed",
          });
        });
      //.catch((err) => toast.error(err.message || 'Failed to toggle status', { title: 'Status change failed' }));
    } else {
      setUsers(
        users.map((x) => (x.id === userId ? { ...x, status: next } : x)),
      );
      toast.success(`${displayName} is now ${next}.`, {
        title: next === "Active" ? "User activated" : "User deactivated",
      });
    }
  };

  const handleSave = async () => {
    if (
      !editingUser2.firstName ||
      !editingUser2.lastName ||
      !editingUser2.email
    ) {
      toast.error("First Name, Last Name, and Email are required.", {
        title: "Missing information",
      });
      return;
    }
    const uname = validateUsername(
      editingUser2.userName,
      users,
      editingUser2.id,
    );

    if (!uname.valid) {
      toast.error(uname.reason, { title: "Invalid username" });
      return;
    }
    // Normalise username to lowercase on save
    editingUser2.userName = (editingUser2.userName || "").trim().toLowerCase();
    const isCreate = !editingUser2.id;

    // Password is required only when creating a new user. Existing users
    // change their password through the Profile page, not this admin form.
    if (isCreate) {
      const pwdError = validators.password(editingUser2.password || "");
      if (pwdError) {
        toast.error(pwdError, { title: "Password does not meet requirements" });
        return;
      }
      if (
        (editingUser2.password || "") !== (editingUser2.confirmPassword || "")
      ) {
        toast.error("Passwords do not match. Please re-enter.", {
          title: "Password mismatch",
        });
        return;
      }
    }

    // Build the payload. confirmPassword + internal UI flags never leave the

    const payload = {
      ...editingUser2,
    };
    delete payload.confirmPassword;
    delete payload._usernameTouched;

    const displayName = `${editingUser2.firstName} ${editingUser2.lastName}`;

    if (isApiConfigured()) {
      setSaving(true);
      try {
        const selectedPermissions = getSelectedPermissions(
          editingUser2.permissions,
        );

        //console.log(
        //  "Selected Permissions:",
        //  JSON.stringify(selectedPermissions, null, 2),
        //);

        const updatedPayload = {
          ...payload,
          selectedPermissions: selectedPermissions,
        };

        const res = await userApi.createSuperAdminUser(updatedPayload);

        if (res.success) {
          await run();
          //setUsers([...users, payload]);
          toast.success(`${displayName} was added to the portal.`, {
            title: "User created",
          });
          setShowDialog(false);
          setEditingUser2(null);
        } else {
          toast.error(res.message, { title: `Error` });
        }
      } catch (err) {
        toast.error(
          err.message || `Failed to ${isCreate ? "create" : "update"} user`,
          {
            title: `Could not ${isCreate ? "create" : "update"} user`,
          },
        );
      } finally {
        setSaving(false);
      }
    } else {
      // Mock mode — do NOT keep the plaintext password in local state.
      const storedPayload = { ...payload };
      delete storedPayload.password;

      if (editingUser.id) {
        setUsers(
          users.map((u) => (u.id === editingUser.id ? storedPayload : u)),
        );
        toast.success(`${displayName} was updated.`, { title: "User updated" });
      } else {
        const newId = Math.max(0, ...users.map((u) => u.id)) + 1;
        setUsers([
          ...users,
          {
            ...storedPayload,
            id: newId,
            lastLogin: null,
            createdAt: new Date().toISOString(),
          },
        ]);
        toast.success(`${displayName} was added to the portal.`, {
          title: "User created",
        });
      }
      setShowDialog(false);
      setEditingUser(null);
    }
  };

  /* ── Table cell renderers ──────────────────────────────── */
  const NameCell = (props) => (
    <td {...props.tdProps} colSpan={props.colSpan} style={props.style}>
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <Avatar
          firstName={props.dataItem.firstName}
          lastName={props.dataItem.lastName}
          role={props.dataItem.role}
          size={32}
        />
        <div style={{ display: "flex", flexDirection: "column", minWidth: 0 }}>
          <span style={{ fontWeight: 600, color: "#1A1D21", fontSize: 13 }}>
            {props.dataItem.firstName} {props.dataItem.lastName}
          </span>
          <span
            style={{
              fontSize: 11,
              color: "#9CA3AF",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {props.dataItem.email}
            <br></br>
            {props.dataItem.taxIds != "N/A" &&
              props.dataItem.role.trim().toLowerCase() === "provider admin" && (
                <>({props.dataItem.taxIds})</>
              )}

            {props.dataItem.isApproved === "true" &&
              props.dataItem.approvedBy && (
                <div style={{ fontSize: 11, color: "#9CA3AF", marginTop: 4 }}>
                  Approved By :{" "}
                  <strong style={{ color: "#16A34A" }}>
                    {props.dataItem.approvedBy}
                  </strong>
                </div>
              )}

            {props.dataItem.isApproved === "false" &&
              props.dataItem.rejectedBy && (
                <div style={{ fontSize: 11, color: "#9CA3AF", marginTop: 4 }}>
                  Rejected By :{" "}
                  <strong style={{ color: "#DC2626" }}>
                    {props.dataItem.rejectedBy}
                  </strong>
                </div>
              )}
          </span>
        </div>
      </div>
    </td>
  );

  const OrgCellT = (props) => (
    <td {...props.tdProps} colSpan={props.colSpan} style={props.style}>
      <div
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 6,
          padding: "3px 10px",
          borderRadius: 999,
          background: "rgba(13,148,136,0.08)",
          border: "1px solid rgba(13,148,136,0.12)",
        }}
      >
        <Building2 size={12} color="#0D9488" strokeWidth={2} />
        <span style={{ fontSize: 12, fontWeight: 600, color: "#0F766E" }}>
          {props.dataItem.orgName}
        </span>
      </div>
    </td>
  );

  const RoleCellT = (props) => (
    <td {...props.tdProps} colSpan={props.colSpan} style={props.style}>
      <RoleBadge role={props.dataItem.role} />
    </td>
  );

  const StatusCellT = (props) => (
    <td {...props.tdProps} colSpan={props.colSpan} style={props.style}>
      <StatusPill
        status={props.dataItem.status}
        onClick={() => toggleStatus(props.dataItem.id)}
      />
    </td>
  );

  const LastLoginCellT = (props) => (
    <td
      {...props.tdProps}
      colSpan={props.colSpan}
      style={{ ...props.style, color: "#6B7280", fontSize: 12 }}
    >
      {relativeDate(props.dataItem.lastLogin)}
    </td>
  );

  const ActionsCellT = (props) => {
    const u = props.dataItem;

    //console.log("USER : "+JSON.stringify(u));
    const active = u.status === "Active";
    const canImp = canImpersonateUser(u);
    return (
      <td {...props.tdProps} colSpan={props.colSpan} style={props.style}>
        <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
          {u.isApproved != null &&
          u?.role?.trim().toLowerCase() === "provider admin" &&
          u.isApproved.trim().toLowerCase() === "pending" ? (
            <>
              {accessPermissions.canApproveProviderAdmin && (
                <>
                  <button
                    name="btnApproveUser"
                    id={`btnApproveUser${u.id}`}
                    onClick={async () => await approveUser(u.id, true)}
                    title={`Approve ${u.firstName} ${u.lastName}`}
                    style={{
                      padding: "5px 10px",
                      borderRadius: 8,
                      border: "none",
                      background: "linear-gradient(135deg, #22C55E, #16A34A)",
                      color: "#fff",
                      fontSize: 12,
                      fontWeight: 700,
                      cursor: "pointer",
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 4,
                      fontFamily: "inherit",
                      boxShadow: "0 2px 6px rgba(139,92,246,0.3)",
                    }}
                  >
                    <UserCheck size={12} strokeWidth={2.5} />
                    Approve
                  </button>
                </>
              )}

              {accessPermissions.canRejectProviderAdmin && (
                <>
                  <button
                    name="btnRejectUser"
                    id={`btnRejectUser${u.id}`}
                    onClick={async () => await approveUser(u.id, false)}
                    title={`Reject ${u.firstName} ${u.lastName}`}
                    style={{
                      padding: "5px 10px",
                      borderRadius: 8,
                      border: "none",
                      marginLeft: "5px",
                      background: "linear-gradient(135deg, #EF4444, #DC2626)",
                      color: "#fff",
                      fontSize: 12,
                      fontWeight: 700,
                      cursor: "pointer",
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 4,
                      fontFamily: "inherit",
                      boxShadow: "0 2px 6px rgba(139,92,246,0.3)",
                    }}
                  >
                    <UserX size={12} strokeWidth={2.5} />
                    Reject
                  </button>
                </>
              )}
            </>
          ) : (
            <>
              {u.isApproved != null &&
              u?.role?.trim().toLowerCase() === "provider admin" &&
              (u.isApproved.trim().toLowerCase() === "pending" ||
                u.isApproved.trim().toLowerCase() === "false") ? (
                <></>
              ) : (
                <>
                  {accessPermissions.canEnableDisabled && (
                    <>
                      <button
                        name="btnToggleStatusTable"
                        onClick={() => toggleStatus(u.id)}
                        title={active ? "Deactivate user" : "Activate user"}
                        style={{
                          padding: "5px 10px",
                          borderRadius: 8,
                          border: `1px solid ${active ? "rgba(217,119,6,0.25)" : "rgba(5,150,105,0.25)"}`,
                          background: active
                            ? "rgba(245,158,11,0.08)"
                            : "rgba(16,185,129,0.08)",
                          color: active ? "#D97706" : "#059669",
                          fontSize: 12,
                          fontWeight: 700,
                          cursor: "pointer",
                          display: "inline-flex",
                          alignItems: "center",
                          gap: 4,
                          fontFamily: "inherit",
                        }}
                      >
                        <Power size={12} strokeWidth={2.5} />
                        {active ? "Deactivate" : "Activate"}
                      </button>
                    </>
                  )}
                </>
              )}

              {accessPermissions.canEditUser && (
                <>
                  <button
                    name="btnEditTable"
                    onClick={() => openEditDialog(u)}
                    title="Edit user"
                    style={tableIconBtn("#0D9488")}
                  >
                    <Edit2 size={13} strokeWidth={2.5} />
                  </button>
                </>
              )}
              {accessPermissions.canDeleteUser && (
                <>
                  <button
                    name="btnDeleteTable"
                    onClick={() => openDeleteDialog(u)}
                    title="Delete user"
                    style={tableIconBtn("#DC2626")}
                  >
                    <Trash2 size={13} strokeWidth={2.5} />
                  </button>
                </>
              )}
              {accessPermissions.canImpersonate && (
                <>
                  {canImp && (
                    <button
                      name="btnImpersonateTable"
                      onClick={async () => await handleImpersonate(u)}
                      title={`View portal as ${u.firstName} ${u.lastName}`}
                      style={{
                        padding: "5px 10px",
                        borderRadius: 8,
                        border: "none",
                        background: "linear-gradient(135deg, #8B5CF6, #7C3AED)",
                        color: "#fff",
                        fontSize: 12,
                        fontWeight: 700,
                        cursor: "pointer",
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 4,
                        fontFamily: "inherit",
                        boxShadow: "0 2px 6px rgba(139,92,246,0.3)",
                      }}
                    >
                      <Eye size={12} strokeWidth={2.5} />
                      View As
                    </button>
                  )}
                </>
              )}
            </>
          )}
        </div>
      </td>
    );
  };

  const tableIconBtn = (color) => ({
    width: 28,
    height: 28,
    borderRadius: 8,
    border: `1px solid ${color}33`,
    background: `${color}0A`,
    color,
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 0,
  });

  const clearFilters = async () => {
    setSearchText("");
    setSearchInputText("");
    setFilterOrg("All");
    setFilterRole("All");
    setFilterStatus("All");
    setFilterProAdminApproveStatus("All");

    const newState = {
      ...dataState,
      skip: 0,
    };
    setDataState(newState);
    setSearchText("");

    setMultiSearchText({
      organization: "",
      role: "",
      status: "",
    });

    await run2(newState, "");
  };
  const hasFilters =
    searchText ||
    filterOrg !== "All" ||
    filterRole !== "All" ||
    filterStatus !== "All";

  const isUserFormValid = () => {
    return (
      validators.required(editingUser2.firstName, "First Name") === null &&
      validators.alpha(editingUser2.firstName) === null &&
      validators.required(editingUser2.lastName, "Last Name") === null &&
      validators.alpha(editingUser2.lastName) === null &&
      validators.required(editingUser2.email, "Email") === null &&
      validators.email(editingUser2.email) === null &&
      validators.required(editingUser2.phone, "Phone") === null &&
      validators.phone(editingUser2.phone) === null &&
      //editingUser2.role
      // &&
      (editingUser2.id ||
        (validateUsername(editingUser2.userName, users, editingUser2.id)
          .valid &&
          validators.password(editingUser2.password || "") === null &&
          editingUser2.password === editingUser2.confirmPassword))
    );
  };

  /* ── Render ────────────────────────────────────────────── */
  return (
    <div className="main-content">
      {pageLoading && (
        <div
          data-cy="page-loader-login"
          style={styles.overlay}
          name="PageLoaderLogin"
          id="PageLoaderLogin"
        >
          <LoadingSpinner message="Please wait..." fullPage="true" />
        </div>
      )}
      {/* Page header */}
      <div className="page-header">
        <div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              marginBottom: 4,
            }}
          >
            <ShieldCheck size={22} color="#DC2626" strokeWidth={2} />
            <h1 style={{ margin: 0 }}>System Users</h1>
          </div>
          <p>
            All users across all organizations in the Central Health network
          </p>
        </div>

        {accessPermissions.canCreateAdminUser && (
          <>
            <button
              onClick={openAddDialog}
              style={{
                padding: "10px 18px",
                borderRadius: 12,
                border: "none",
                background: "linear-gradient(135deg, #0D9488, #0F766E)",
                color: "#fff",
                fontSize: 14,
                fontWeight: 700,
                cursor: "pointer",
                display: "inline-flex",
                alignItems: "center",
                gap: 8,
                fontFamily: "inherit",
                boxShadow: "0 4px 12px rgba(13,148,136,0.25)",
                transition: "all 0.15s",
              }}
                          name="btnAddAdminUser"
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-1px)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
              }}
            >
              <UserPlus size={15} strokeWidth={2.5} />
              Add Admin User
            </button>
          </>
        )}
      </div>

      {/* Stat cards */}
      <div
        className="stat-cards"
        /*style={{ gridTemplateColumns: 'repeat(5, 1fr)', marginBottom: 20 }}*/
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
          gap: "16px",
          marginBottom: 20,
        }}
      >
        <div
          className="stat-card"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
          }}
        >
          <div className="stat-icon teal">
            <Users size={20} strokeWidth={2} />
          </div>
          <div className="stat-value">{stats.total}</div>
          <div className="stat-label">Total Users</div>
        </div>
        <div
          className="stat-card"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
          }}
        >
          <div className="stat-icon blue">
            <Building2 size={20} strokeWidth={2} />
          </div>
          <div className="stat-value">{stats.orgs}</div>
          <div className="stat-label">Organizations</div>
        </div>
        <div
          className="stat-card"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
          }}
        >
          <div className="stat-icon green">
            <UserCheck size={20} strokeWidth={2} />
          </div>
          <div className="stat-value">{stats.active}</div>
          <div className="stat-label">Active</div>
        </div>
        <div
          className="stat-card"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
          }}
        >
          <div className="stat-icon orange">
            <UserX size={20} strokeWidth={2} />
          </div>
          <div className="stat-value">{stats.inactive}</div>
          <div className="stat-label">Inactive</div>
        </div>
        <div
          className="stat-card"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
          }}
        >
          <div className="stat-icon danger">
            <Shield size={20} strokeWidth={2} />
          </div>
          <div className="stat-value">{stats.superAdmins}</div>
          <div className="stat-label">Super Admins</div>
        </div>
      </div>

      {/* Toolbar */}
      <div className="card" style={{ marginBottom: 20 }}>
        <div
          style={{
            display: "flex",
            gap: 12,
            alignItems: "center",
            flexWrap: "wrap",
          }}
        >
          <div
            style={{ position: "relative", flex: "1 1 260px", minWidth: 200 }}
          >
            <span
              style={{
                position: "absolute",
                left: 14,
                top: "50%",
                transform: "translateY(-50%)",
                color: "#9CA3AF",
                display: "flex",
              }}
            >
              <Search size={16} />
            </span>
            <input
              type="search"
              placeholder="Search name, email, or organization..."
              value={searchInputText}
              // onChange={(e) => setSearchText(e.target.value)}
              onChange={(e) => {
                const value = e.target.value;

                setSearchText(value);
                setSearchInputText(value);

                const newState = {
                  ...dataState,
                  skip: 0,
                };

                setDataState(newState);

                // Clear previous timer
                if (searchTimeoutRef.current) {
                  clearTimeout(searchTimeoutRef.current);
                }

                // Set new timer (3 seconds)
                searchTimeoutRef.current = setTimeout(async () => {
                  await run2(newState, value);
                }, 3000);
              }}
              style={{
                width: "100%",
                padding: "10px 14px 10px 40px",
                borderRadius: 10,
                border: "1.5px solid #E8ECF0",
                fontSize: 14,
                fontFamily: "inherit",
                background: "#F8FAFB",
                outline: "none",
                transition: "all 0.15s",
              }}
              onFocus={(e) => {
                e.target.style.borderColor = "#0D9488";
                e.target.style.background = "#fff";
              }}
              onBlur={(e) => {
                e.target.style.borderColor = "#E8ECF0";
                e.target.style.background = "#F8FAFB";
              }}
            />
          </div>

          <div
            style={{
              display: "flex",
              gap: 8,
              alignItems: "center",
              flexWrap: "wrap",
            }}
          >
            <Filter size={15} color="#9CA3AF" />
            <select
              value={filterOrg}
              onChange={async (e) => {
                setFilterOrg(e.target.value);

                const newState = {
                  ...dataState,
                  skip: 0,
                };

                setDataState(newState);

                if (e.target.value.trim().toLowerCase() == "all") {
                  //setSearchText('');
                  //setMultiSearchText((prev) => ({
                  //    ...prev,
                  //    organization: "",
                  //}));
                  const newSearch = {
                    ...multiSearchText,
                    organization: "",
                  };
                  setMultiSearchText(newSearch);
                  setSearchText(JSON.stringify(newSearch));
                  await run2(newState, JSON.stringify(newSearch));
                } else {
                  //setSearchText(e.target.value);
                  //setMultiSearchText((prev) => ({
                  //    ...prev,
                  //    organization: e.target.value,
                  //}));

                  const newSearch = {
                    ...multiSearchText,
                    organization: e.target.value,
                  };
                  setMultiSearchText(newSearch);
                  setSearchText(JSON.stringify(newSearch));
                  await run2(newState, JSON.stringify(newSearch));
                }
              }}
              style={selectStyle}
              name="selOrganization"
            >
              <option value="All">All Organizations</option>
              {orgs.map((org) => (
                <option key={org.name} value={org.name}>
                  {org.name}
                </option>
              ))}
            </select>
            <select
              value={filterRole}
              //onChange={(e) => setFilterRole(e.target.value)}
              onChange={async (e) => {
                setFilterRole(e.target.value);

                const newState = {
                  ...dataState,
                  skip: 0,
                };

                setDataState(newState);

                if (e.target.value.trim().toLowerCase() == "all") {
                  //  setSearchText('');
                  //setMultiSearchText((prev) => ({
                  //    ...prev,
                  //    role: "",
                  //}));

                  const newSearch = {
                    ...multiSearchText,
                    role: "",
                  };

                  setMultiSearchText(newSearch);
                  setSearchText(JSON.stringify(newSearch));
                  await run2(newState, JSON.stringify(newSearch));
                } else {
                  //  setSearchText(e.target.value);

                  //setMultiSearchText((prev) => ({
                  //    ...prev,
                  //    role: e.target.value,
                  //}));

                  const newSearch = {
                    ...multiSearchText,
                    role: e.target.value,
                  };

                  setMultiSearchText(newSearch);
                  setSearchText(JSON.stringify(newSearch));
                  await run2(newState, JSON.stringify(newSearch));
                }
              }}

              style={selectStyle}
              name="selRole"
            >
              <option value="All">All Roles</option>

              {roles.map((role) => (
                <option key={role.Id} value={role.Name}>
                  {role.Name}
                </option>
              ))}
            </select>
            <select
              value={filterStatus}
              //                          onChange={(e) => setFilterStatus(e.target.value)}
              onChange={async (e) => {
                setFilterStatus(e.target.value);

                const newState = {
                  ...dataState,
                  skip: 0,
                };

                setDataState(newState);

                if (e.target.value.trim().toLowerCase() == "all") {
                  //  setSearchText('');
                  //setMultiSearchText((prev) => ({
                  //    ...prev,
                  //    status: "",
                  //}));
                  //await run2(newState, '');

                  const newSearch = {
                    ...multiSearchText,
                    status: "",
                  };

                  setMultiSearchText(newSearch);
                  setSearchText(JSON.stringify(newSearch));
                  await run2(newState, JSON.stringify(newSearch));
                } else {
                  //setSearchText(e.target.value);
                  //setMultiSearchText((prev) => ({
                  //    ...prev,
                  //    status: e.target.value,
                  //}));
                  //await run2(newState, e.target.value);

                  const newSearch = {
                    ...multiSearchText,
                    status: e.target.value,
                  };

                  setMultiSearchText(newSearch);
                  setSearchText(JSON.stringify(newSearch));
                  await run2(newState, JSON.stringify(newSearch));
                }
              }}
              style={selectStyle}
              name="selStatus"
            >
              <option value="All">All Statuses</option>
              <option value="Active">Active only</option>
              <option value="Inactive">Inactive only</option>
            </select>

            <select
              value={filterProAdminApproveStatus}
              //                          onChange={(e) => setFilterStatus(e.target.value)}
              onChange={async (e) => {
                setFilterProAdminApproveStatus(e.target.value);

                const newState = {
                  ...dataState,
                  skip: 0,
                };

                setDataState(newState);

                if (e.target.value.trim().toLowerCase() == "all") {
                  const newSearch = {
                    ...multiSearchText,
                    proAdminApproveStatus: "",
                  };

                  setMultiSearchText(newSearch);
                  setSearchText(JSON.stringify(newSearch));
                  await run2(newState, JSON.stringify(newSearch));
                } else {
                  const newSearch = {
                    ...multiSearchText,
                    proAdminApproveStatus: e.target.value,
                  };

                  setMultiSearchText(newSearch);
                  setSearchText(JSON.stringify(newSearch));
                  await run2(newState, JSON.stringify(newSearch));
                }
              }}
              style={selectStyle}
              name="selApprroveProAdmin"
            >
              <option value="All">All Provider Admin</option>
              <option value="pending">Pending Provider Admins</option>
              <option value="true">Approved Provider Admins</option>
              <option value="false">Rejected Provider Admins</option>
            </select>
          </div>

          {/* View toggle */}
          <div
            style={{
              display: "flex",
              background: "#F1F5F9",
              borderRadius: 10,
              padding: 3,
              gap: 2,
            }}
          >
            <button
              onClick={() => setViewMode("cards")}
              style={toggleBtnStyle(viewMode === "cards")}
              title="Card view"
              aria-pressed={viewMode === "cards"}
            >
              <LayoutGrid size={14} strokeWidth={2.5} />
              Cards
            </button>
            <button
              onClick={() => setViewMode("table")}
              style={toggleBtnStyle(viewMode === "table")}
              title="Table view"
              aria-pressed={viewMode === "table"}
            >
              <List size={14} strokeWidth={2.5} />
              Table
            </button>
          </div>
        </div>

        {hasFilters && (
          <div
            style={{
              marginTop: 12,
              paddingTop: 12,
              borderTop: "1px solid #F1F5F9",
              fontSize: 13,
              color: "#6B7280",
              display: "flex",
              alignItems: "center",
              gap: 8,
              flexWrap: "wrap",
            }}
          >
            <span>
              Showing{" "}
              <strong style={{ color: "#1A1D21" }}>{users.length}</strong> of{" "}
              {totalRecords} users
            </span>
            <button
              onClick={clearFilters}
              style={{
                background: "none",
                border: "none",
                color: "#0D9488",
                fontWeight: 600,
                fontSize: 13,
                cursor: "pointer",
                fontFamily: "inherit",
                padding: 0,
              }}
            >
              Clear filters
            </button>
          </div>
        )}
      </div>

      {/* Body */}
      {loading && <LoadingSpinner message="Loading system users..." />}
      {error && (
        <ErrorCard message={error} onRetry={() => window.location.reload()} />
      )}
      <div style={{ position: "relative" }}>
        {gridLoading && (
          <div style={styles.gridOverlay}>
            <LoadingSpinner data-cy="grid-loader" message="Loading Users..." />
          </div>
        )}

        {!loading &&
          !error &&
          //filteredUsers.length === 0 ? (
          (totalRecords === 0 ? (
            <EmptyState hasFilters={hasFilters} />
          ) : viewMode === "cards" ? (
            <>
              <div
                style={{
                  display: "grid",
                  // Lowered from 320→280 so a single card still fits on a
                  // 316px iframe / 320px phone viewport without overflow.
                  gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
                  gap: 16,
                }}
              >
                {gridData.data.map((u) => (
                  <SystemUserCard
                    key={u.id}
                    user={u}
                    canImpersonate={canImpersonateUser(u)}
                    // onImpersonate={handleImpersonate}
                    onImpersonate={async () => await handleImpersonate(u)}
                    onToggleStatus={toggleStatus}
                    onApproveUser={approveUser}
                    onEdit={openEditDialog}
                    onDelete={openDeleteDialog}
                    onViewActivity={setActivityUser}
                    accessPermissions={accessPermissions}
                  />
                ))}
              </div>
              <CardsPagination
                //total={gridData.total}

                //skip={dataState.skip}
                //take={dataState.take}
                total={gridData.total}
                skip={dataState.skip}
                take={dataState.take}
                //  onPageChange={({ skip, take }) => setDataState((s) => ({ ...s, skip, take }))}
                onPageChange={async ({ skip, take }) => {
                  const newState = {
                    ...dataState,
                    skip,
                    take,
                  };

                  setDataState(newState);
                  await run2(newState, searchText);
                }}
                pageSizes={[10, 20, 50]}
              />
            </>
          ) : (
            <div style={{ overflow: "hidden", borderRadius: 16 }}>
              <div className="grid-scroll-wrapper">
                {/*<Grid*/}
                {/*  data={filteredUsers}*/}
                {/*  sortable={true}*/}
                {/*  pageable={{ pageSizes: [10, 20, 50] }}*/}
                {/*  style={{ border: 'none' }}*/}
                {/*>*/}
                <Grid
                  // data={gridData}
                  data={gridData.data}
                  total={gridData.total}
                  skip={dataState.skip}
                  take={dataState.take}
                  sort={dataState.sort}
                  sortable={true}
                  resizable={true}
                  scrollable="scrollable"
                  reorderable={true}
                  pageable={{ pageSizes: [10, 20, 50] }}
                  /*onDataStateChange={(e) => setDataState(e.dataState)}*/
                  /*{...dataState}*/
                  onDataStateChange={async (e) => {
                    setDataState(e.dataState);
                    await run2(e.dataState, searchText);
                  }}
                  loading={gridLoading}
                  style={{ border: "none" }}
                >
                  <GridColumn
                    field="firstName"
                    title="User"
                    width="260px"
                    cells={{ data: NameCell }}
                  />
                  <GridColumn
                    field="orgName"
                    title="Organization"
                    width="220px"
                    cells={{ data: OrgCellT }}
                  />
                  <GridColumn
                    field="role"
                    title="Role"
                    width="130px"
                    cells={{ data: RoleCellT }}
                  />
                  <GridColumn
                    field="status"
                    title="Status"
                    width="120px"
                    cells={{ data: StatusCellT }}
                  />
                  <GridColumn
                    field="lastLogin"
                    title="Last Login"
                    width="130px"
                    cells={{ data: LastLoginCellT }}
                  />
                  <GridColumn
                    field="registerDate"
                    title="Registered On"
                    width="130px"
                  />
                  <GridColumn
                    title="Actions"
                    width="220px"
                    cells={{ data: ActionsCellT }}
                  />
                </Grid>
              </div>
            </div>
          ))}
      </div>

      {/* ── Edit User Dialog ────────────────────────── */}
      {showEditDialog && editingUser && (
        <Dialog
          title={`Edit User — ${editingUser.firstName} ${editingUser.lastName}`}
          onClose={() => {
            setShowEditDialog(false);
            setEditingUser(null);
          }}
          /*width={620}*/
          width={viewportWidth < 640 ? Math.max(viewportWidth - 24, 300) : 560}
        >
          <div style={{ padding: "8px 0" }}>
            <div className="form-grid">
              <div className="form-group">
                <label className="required">First Name</label>
                <input
                  type="text"
                  value={editingUser.firstName}
                  onChange={(e) =>
                    setEditingUser({
                      ...editingUser,
                      firstName: e.target.value,
                    })
                  }
                  placeholder="First name"
                />
              </div>
              <div className="form-group">
                <label className="required">Last Name</label>
                <input
                  type="text"
                  value={editingUser.lastName}
                  onChange={(e) =>
                    setEditingUser({ ...editingUser, lastName: e.target.value })
                  }
                  placeholder="Last name"
                />
              </div>
              <div className="form-group" style={{ gridColumn: "1 / -1" }}>
                <label className="required">Email</label>
                <input
                  type="email"
                  value={editingUser.email}
                  onChange={(e) =>
                    setEditingUser({ ...editingUser, email: e.target.value })
                  }
                  placeholder="user@organization.com"
                  disabled
                />
              </div>
              <div className="form-group">
                <label>Phone</label>
                <input
                  name="selEditPhone"
                  type="tel"
                  value={editingUser.phone || ""}
                  onChange={(e) => {
                    const digits = e.target.value
                      .replace(/\D/g, "")
                      .slice(0, 10);

                    let formatted = digits;

                    if (digits.length > 6) {
                      formatted = `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
                    } else if (digits.length > 3) {
                      formatted = `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
                    } else if (digits.length > 0) {
                      formatted = `(${digits}`;
                    }
                    setEditingUser({
                      ...editingUser,
                      //phone: e.target.value
                      phone: formatted,
                    });
                  }}
                  placeholder="(512) 555-0000"
                />
              </div>
              {/*<div className="form-group">*/}
              {/*  <label className="required">Organization</label>*/}
              {/*                <select*/}
              {/*  name="selEditOrg"*/}
              {/*    value={editingUser.orgName}*/}
              {/*    onChange={(e) => setEditingUser({ ...editingUser, orgName: e.target.value })}*/}
              {/*  >*/}
              {/*    {orgs.map(o => (*/}
              {/*        <option value={o.name}>{o.name}</option>*/}
              {/*    ))}*/}
              {/*  </select>*/}
              {/*</div>*/}
              {/*<div className="form-group">*/}
              {/*  <label className="required">Role</label>*/}
              {/*                <select*/}
              {/*                    name="selEditRole"*/}
              {/*    value={editingUser.role}*/}
              {/*    onChange={(e) => setEditingUser({ ...editingUser, role: e.target.value })}*/}
              {/*  >*/}
              {/*    */}
              {/*<option value="Super Admin">Super Admin</option>*/}
              {/*    */}
              {/*<option value="Admin">Admin</option>*/}
              {/*    */}
              {/*<option value="Provider">Provider</option>*/}
              {/*    */}
              {/*<option value="Staff">Staff</option>*/}
              {/*                    */}
              {/*<option value="Viewer">Viewer</option>*/}

              {/*                    {roles.map((role) => (*/}
              {/*                        <option key={role.Id} value={role.Name}>*/}
              {/*                            {role.Name}*/}
              {/*                        </option>*/}
              {/*                    ))}*/}
              {/*  </select>*/}
              {/*</div>*/}
              <div className="form-group" style={{ gridColumn: "1 / -1" }}>
                <label>Status</label>
                <div style={{ display: "flex", gap: 10, marginTop: 4 }}>
                  {["Active", "Inactive"].map((s) => (
                    <label
                      key={s}
                      style={{
                        flex: 1,
                        display: "flex",
                        alignItems: "center",
                        gap: 10,
                        padding: "12px 14px",
                        borderRadius: 10,
                        cursor: "pointer",
                        border: `1.5px solid ${editingUser.status === s ? "#0D9488" : "#E8ECF0"}`,
                        background:
                          editingUser.status === s
                            ? "rgba(13,148,136,0.04)"
                            : "#fff",
                        transition: "all 0.15s",
                      }}
                    >
                      <input
                        type="radio"
                        name="status"
                        checked={editingUser.status === s}
                        onChange={() =>
                          setEditingUser({ ...editingUser, status: s })
                        }
                        style={{ accentColor: "#0D9488" }}
                      />
                      <Circle
                        size={9}
                        strokeWidth={0}
                        fill={s === "Active" ? "#10B981" : "#9CA3AF"}
                      />
                      <span
                        style={{
                          fontSize: 13,
                          fontWeight: 600,
                          color: "#1A1D21",
                        }}
                      >
                        {s}
                      </span>
                    </label>
                  ))}
                </div>
              </div>

              {/* ============================================================
    ACCESS PERMISSIONS
============================================================ */}
              {editingUser?.role?.trim().toLowerCase() === "admin" && (
                <>
                  <div
                    className="form-group"
                    style={{
                      gridColumn: "1 / -1",
                      marginTop: 8,
                      paddingTop: 20,
                      borderTop: "1px solid #E8ECF0",
                    }}
                  >
                    {/* --------------------------------------------------------
        Header
    -------------------------------------------------------- */}

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "flex-start",
                        gap: 12,
                        marginBottom: 14,
                      }}
                    >
                      <div>
                        <div
                          style={{
                            fontSize: 15,
                            fontWeight: 700,
                            color: "#1A1D21",
                          }}
                        >
                          Access Permissions
                        </div>

                        <div
                          style={{
                            fontSize: 12,
                            color: "#6B7280",
                            marginTop: 4,
                          }}
                        >
                          Select the pages and functionality this user is
                          allowed to access.
                        </div>

                        {/* Permission count */}

                        {(() => {
                          const count = getPermissionCount(
                            editingUser.permissions,
                          );

                          return (
                            <div
                              style={{
                                fontSize: 11,
                                color: "#0D9488",
                                fontWeight: 600,
                                marginTop: 6,
                              }}
                            >
                              {count.selected} of {count.total} permissions
                              selected
                            </div>
                          );
                        })()}
                      </div>

                      {/* ----------------------------------------------------
            Select All / Clear All
        ---------------------------------------------------- */}

                      <div
                        style={{
                          display: "flex",
                          gap: 8,
                          flexShrink: 0,
                        }}
                      >
                        <button
                          type="button"
                          onClick={() => {
                            setEditingUser((prev) => ({
                              ...prev,
                              permissions: createAllPermissions(),
                            }));
                          }}
                          style={{
                            padding: "6px 10px",
                            borderRadius: 7,
                            border: "1px solid rgba(13,148,136,0.25)",
                            background: "rgba(13,148,136,0.06)",
                            color: "#0D9488",
                            fontSize: 11,
                            fontWeight: 700,
                            cursor: "pointer",
                          }}
                        >
                          Select All
                        </button>

                        <button
                          type="button"
                          onClick={() => {
                            setEditingUser((prev) => ({
                              ...prev,
                              permissions: createEmptyPermissions(),
                            }));
                          }}
                          style={{
                            padding: "6px 10px",
                            borderRadius: 7,
                            border: "1px solid #E8ECF0",
                            background: "#fff",
                            color: "#6B7280",
                            fontSize: 11,
                            fontWeight: 700,
                            cursor: "pointer",
                          }}
                        >
                          Clear All
                        </button>
                      </div>
                    </div>

                    {/* ========================================================
        PERMISSION CONTAINER
    ======================================================== */}

                    <div
                      style={{
                        border: "1px solid #E8ECF0",
                        borderRadius: 10,
                        overflow: "hidden",
                        background: "#fff",
                      }}
                    >
                      {PERMISSION_GROUPS.map((group, groupIndex) => {
                        /* ==================================================
                                                                   NORMAL APPLICATION PAGE
                                                                ================================================== */

                        if (group.type === "page") {
                          const selectedCount = group.permissions.filter(
                            (permission) =>
                              editingUser.permissions?.[group.key]?.[
                                permission.key
                              ] === true,
                          ).length;

                          const allSelected =
                            selectedCount === group.permissions.length;

                          const someSelected =
                            selectedCount > 0 && !allSelected;

                          return (
                            <div
                              key={group.key}
                              style={{
                                padding: "15px 16px",
                                borderBottom:
                                  groupIndex !== PERMISSION_GROUPS.length - 1
                                    ? "1px solid #E8ECF0"
                                    : "none",
                              }}
                            >
                              {/* Page Header */}

                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  marginBottom: 10,
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 9,
                                  }}
                                >
                                  <input
                                    type="checkbox"
                                    checked={allSelected}
                                    ref={(element) => {
                                      if (element) {
                                        element.indeterminate = someSelected;
                                      }
                                    }}
                                    onChange={() => {
                                      setEditingUser((prev) => ({
                                        ...prev,

                                        permissions: {
                                          ...prev.permissions,

                                          [group.key]: group.permissions.reduce(
                                            (result, permission) => {
                                              result[permission.key] =
                                                !allSelected;

                                              return result;
                                            },
                                            {},
                                          ),
                                        },
                                      }));
                                    }}
                                    style={{
                                      width: 15,
                                      height: 15,
                                      accentColor: "#0D9488",
                                      cursor: "pointer",
                                    }}
                                  />

                                  <div>
                                    <div
                                      style={{
                                        fontSize: 13,
                                        fontWeight: 700,
                                        color: "#1A1D21",
                                      }}
                                    >
                                      {group.label}
                                    </div>

                                    <div
                                      style={{
                                        fontSize: 10,
                                        color: "#9CA3AF",
                                        marginTop: 2,
                                      }}
                                    >
                                      {selectedCount} of{" "}
                                      {group.permissions.length} selected
                                    </div>
                                  </div>
                                </div>

                                <button
                                  type="button"
                                  onClick={() => {
                                    setEditingUser((prev) => ({
                                      ...prev,

                                      permissions: {
                                        ...prev.permissions,

                                        [group.key]: group.permissions.reduce(
                                          (result, permission) => {
                                            result[permission.key] =
                                              !allSelected;

                                            return result;
                                          },
                                          {},
                                        ),
                                      },
                                    }));
                                  }}
                                  style={{
                                    border: "none",
                                    background: "transparent",
                                    color: "#0D9488",
                                    fontSize: 11,
                                    fontWeight: 700,
                                    cursor: "pointer",
                                  }}
                                >
                                  {allSelected ? "Clear All" : "Select All"}
                                </button>
                              </div>

                              {/* Page Actions */}

                              <div
                                style={{
                                  display: "grid",
                                  gridTemplateColumns:
                                    "repeat(auto-fit, minmax(180px, 1fr))",
                                  gap: 8,
                                }}
                              >
                                {group.permissions.map((permission) => {
                                  const checked =
                                    editingUser.permissions?.[group.key]?.[
                                      permission.key
                                    ] === true;

                                  return (
                                    <label
                                      key={permission.key}
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 9,
                                        padding: "9px 10px",
                                        borderRadius: 8,
                                        border: `1px solid ${
                                          checked ? "#0D9488" : "#E8ECF0"
                                        }`,
                                        background: checked
                                          ? "rgba(13,148,136,0.05)"
                                          : "#fff",
                                        cursor: "pointer",
                                        transition: "all 0.15s",
                                      }}
                                    >
                                      <input
                                        type="checkbox"
                                        checked={checked}
                                        onChange={(e) => {
                                          const value = e.target.checked;

                                          setEditingUser((prev) => ({
                                            ...prev,

                                            permissions: {
                                              ...prev.permissions,

                                              [group.key]: {
                                                ...prev.permissions?.[
                                                  group.key
                                                ],

                                                [permission.key]: value,
                                              },
                                            },
                                          }));
                                        }}
                                        style={{
                                          width: 15,
                                          height: 15,
                                          accentColor: "#0D9488",
                                          cursor: "pointer",
                                        }}
                                      />

                                      <span
                                        style={{
                                          fontSize: 12,
                                          fontWeight: 600,
                                          color: checked
                                            ? "#0D766D"
                                            : "#374151",
                                        }}
                                      >
                                        {permission.label}
                                      </span>
                                    </label>
                                  );
                                })}
                              </div>
                            </div>
                          );
                        }

                        /* ==================================================
                                                                   SECTION - SUPER ADMIN
                                                                ================================================== */

                        if (group.type === "section") {
                          return (
                            <div
                              key={group.key}
                              style={{
                                padding: "0",
                                borderBottom:
                                  groupIndex !== PERMISSION_GROUPS.length - 1
                                    ? "1px solid #E8ECF0"
                                    : "none",
                              }}
                            >
                              {/* =================================================
                            SECTION HEADER
                        ================================================= */}

                              <div
                                style={{
                                  padding: "16px 16px 12px",
                                  background:
                                    "linear-gradient(180deg, #F8FAFC 0%, #F4F7F8 100%)",
                                  borderBottom: "1px solid #E8ECF0",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 10,
                                    }}
                                  >
                                    <div
                                      style={{
                                        width: 32,
                                        height: 32,
                                        borderRadius: 8,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        background: "rgba(13,148,136,0.10)",
                                        color: "#0D9488",
                                        fontSize: 14,
                                        fontWeight: 800,
                                      }}
                                    >
                                      SA
                                    </div>

                                    <div>
                                      <div
                                        style={{
                                          fontSize: 14,
                                          fontWeight: 800,
                                          color: "#1A1D21",
                                        }}
                                      >
                                        {group.label}
                                      </div>

                                      <div
                                        style={{
                                          fontSize: 11,
                                          color: "#6B7280",
                                          marginTop: 2,
                                        }}
                                      >
                                        Administrative pages and functionality
                                      </div>
                                    </div>
                                  </div>

                                  {/* Select entire Super Admin */}

                                  <button
                                    type="button"
                                    onClick={() => {
                                      const allChildrenSelected =
                                        group.children.every((child) =>
                                          child.permissions.every(
                                            (permission) =>
                                              editingUser.permissions?.[
                                                group.key
                                              ]?.[child.key]?.[
                                                permission.key
                                              ] === true,
                                          ),
                                        );

                                      setEditingUser((prev) => ({
                                        ...prev,

                                        permissions: {
                                          ...prev.permissions,

                                          [group.key]: group.children.reduce(
                                            (result, child) => {
                                              result[child.key] =
                                                child.permissions.reduce(
                                                  (childResult, permission) => {
                                                    childResult[
                                                      permission.key
                                                    ] = !allChildrenSelected;

                                                    return childResult;
                                                  },
                                                  {},
                                                );

                                              return result;
                                            },
                                            {},
                                          ),
                                        },
                                      }));
                                    }}
                                    style={{
                                      padding: "6px 10px",
                                      borderRadius: 7,
                                      border: "1px solid rgba(13,148,136,0.25)",
                                      background: "rgba(13,148,136,0.06)",
                                      color: "#0D9488",
                                      fontSize: 11,
                                      fontWeight: 700,
                                      cursor: "pointer",
                                    }}
                                  >
                                    Select All
                                  </button>
                                </div>
                              </div>

                              {/* =================================================
                            SUPER ADMIN CHILDREN
                        ================================================= */}

                              {group.children.map((child, childIndex) => {
                                const selectedCount = child.permissions.filter(
                                  (permission) =>
                                    editingUser.permissions?.[group.key]?.[
                                      child.key
                                    ]?.[permission.key] === true,
                                ).length;

                                const allSelected =
                                  selectedCount === child.permissions.length;

                                const someSelected =
                                  selectedCount > 0 && !allSelected;

                                return (
                                  <div
                                    key={child.key}
                                    style={{
                                      padding: "15px 16px",
                                      borderBottom:
                                        childIndex !== group.children.length - 1
                                          ? "1px solid #F0F2F4"
                                          : "none",
                                    }}
                                  >
                                    {/* Child Header */}

                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        marginBottom: 10,
                                      }}
                                    >
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: 9,
                                        }}
                                      >
                                        <input
                                          type="checkbox"
                                          checked={allSelected}
                                          ref={(element) => {
                                            if (element) {
                                              element.indeterminate =
                                                someSelected;
                                            }
                                          }}
                                          onChange={() => {
                                            setEditingUser((prev) => ({
                                              ...prev,

                                              permissions: {
                                                ...prev.permissions,

                                                [group.key]: {
                                                  ...prev.permissions?.[
                                                    group.key
                                                  ],

                                                  [child.key]:
                                                    child.permissions.reduce(
                                                      (result, permission) => {
                                                        result[permission.key] =
                                                          !allSelected;

                                                        return result;
                                                      },
                                                      {},
                                                    ),
                                                },
                                              },
                                            }));
                                          }}
                                          style={{
                                            width: 15,
                                            height: 15,
                                            accentColor: "#0D9488",
                                            cursor: "pointer",
                                          }}
                                        />

                                        <div>
                                          <div
                                            style={{
                                              fontSize: 13,
                                              fontWeight: 700,
                                              color: "#1A1D21",
                                            }}
                                          >
                                            {child.label}
                                          </div>

                                          <div
                                            style={{
                                              fontSize: 10,
                                              color: "#9CA3AF",
                                              marginTop: 2,
                                            }}
                                          >
                                            {selectedCount} of{" "}
                                            {child.permissions.length} selected
                                          </div>
                                        </div>
                                      </div>

                                      <button
                                        type="button"
                                        onClick={() => {
                                          setEditingUser((prev) => ({
                                            ...prev,

                                            permissions: {
                                              ...prev.permissions,

                                              [group.key]: {
                                                ...prev.permissions?.[
                                                  group.key
                                                ],

                                                [child.key]:
                                                  child.permissions.reduce(
                                                    (result, permission) => {
                                                      result[permission.key] =
                                                        !allSelected;

                                                      return result;
                                                    },
                                                    {},
                                                  ),
                                              },
                                            },
                                          }));
                                        }}
                                        style={{
                                          border: "none",
                                          background: "transparent",
                                          color: "#0D9488",
                                          fontSize: 11,
                                          fontWeight: 700,
                                          cursor: "pointer",
                                        }}
                                      >
                                        {allSelected
                                          ? "Clear All"
                                          : "Select All"}
                                      </button>
                                    </div>

                                    {/* Child Permissions */}

                                    <div
                                      style={{
                                        display: "grid",
                                        gridTemplateColumns:
                                          "repeat(auto-fit, minmax(180px, 1fr))",
                                        gap: 8,
                                      }}
                                    >
                                      {child.permissions.map((permission) => {
                                        const checked =
                                          editingUser.permissions?.[
                                            group.key
                                          ]?.[child.key]?.[permission.key] ===
                                          true;

                                        return (
                                          <label
                                            key={`${group.key}-${child.key}-${permission.key}`}
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                              gap: 9,
                                              padding: "9px 10px",
                                              borderRadius: 8,
                                              border: `1px solid ${
                                                checked ? "#0D9488" : "#E8ECF0"
                                              }`,
                                              background: checked
                                                ? "rgba(13,148,136,0.05)"
                                                : "#fff",
                                              cursor: "pointer",
                                              transition: "all 0.15s",
                                            }}
                                          >
                                            <input
                                              type="checkbox"
                                              checked={checked}
                                              onChange={(e) => {
                                                const value = e.target.checked;

                                                setEditingUser((prev) => ({
                                                  ...prev,

                                                  permissions: {
                                                    ...prev.permissions,

                                                    [group.key]: {
                                                      ...prev.permissions?.[
                                                        group.key
                                                      ],

                                                      [child.key]: {
                                                        ...prev.permissions?.[
                                                          group.key
                                                        ]?.[child.key],

                                                        [permission.key]: value,
                                                      },
                                                    },
                                                  },
                                                }));
                                              }}
                                              style={{
                                                width: 15,
                                                height: 15,
                                                accentColor: "#0D9488",
                                                cursor: "pointer",
                                              }}
                                            />

                                            <span
                                              style={{
                                                fontSize: 12,
                                                fontWeight: 600,
                                                color: checked
                                                  ? "#0D766D"
                                                  : "#374151",
                                              }}
                                            >
                                              {permission.label}
                                            </span>
                                          </label>
                                        );
                                      })}
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          );
                        }

                        return null;
                      })}
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
          <DialogActionsBar>
            <Button
              onClick={() => {
                setShowEditDialog(false);
                setEditingUser(null);
              }}
            >
              Cancel
            </Button>
            <Button
              themeColor="primary"
              onClick={handleSaveEdit}
              disabled={saving}
            >
              {saving ? "Saving..." : "Save Changes"}
            </Button>
          </DialogActionsBar>
        </Dialog>
      )}

      {/* ── Add User Dialog ────────────────────────────────────── */}
      {showDialog && (
        <Dialog
          /*title={editingUser.id ? 'Edit User' : 'Add New User'}*/
          title={"Add New Admin User"}
          onClose={closeDialog}
          className="user-dialog"
          width={viewportWidth < 640 ? Math.max(viewportWidth - 24, 300) : 560}
        >
          <div style={{ padding: "8px 0" }}>
            <div className="form-grid">
              <div className="form-group">
                <label className="required">First Name</label>
                <ValidatedInput
                  //  type="text"
                  required
                  value={editingUser2.firstName}
                  onChange={(v) => {
                    updateField("firstName", v);
                    const firstName = v;
                    // Auto-suggest a username for NEW users only (id is null)
                    // and only when the user hasn't manually typed one yet.
                    if (!editingUser2.id && !editingUser2._usernameTouched) {
                      const takenSet = new Set(
                        users.map((u) => (u.userName || "").toLowerCase()),
                      );
                      //const suggestion = suggestUsername(editingUser.firstName, editingUser.lastName, takenSet);
                      const suggestion = suggestUsername(
                        firstName,
                        editingUser2.lastName,
                        takenSet,
                      );
                      setEditingUser2({
                        ...editingUser2,
                        firstName,
                        userName: suggestion,
                      });
                      //setEditingUser({ ...editingUser, username: suggestion });
                    } else {
                      setEditingUser2({ ...editingUser2, firstName });
                    }
                  }}

                  validate={(v) =>
                    validators.required(v, "First Name") || validators.alpha(v)
                  }
                  placeholder="Enter first name"
                />
              </div>
              <div className="form-group">
                <label className="required">Last Name</label>
                <ValidatedInput
                  /// type="text"
                  required
                  value={editingUser2.lastName}
                  onChange={(v) => {
                    updateField("lastName", v);
                    //const lastName = e.target.value;
                    const lastName = v;
                    if (!editingUser2.id && !editingUser2._usernameTouched) {
                      const takenSet = new Set(
                        users.map((u) => (u.userName || "").toLowerCase()),
                      );
                      const suggestion = suggestUsername(
                        editingUser2.firstName,
                        lastName,
                        takenSet,
                      );

                      setEditingUser2({
                        ...editingUser2,
                        lastName,
                        userName: suggestion,
                      });
                    } else {
                      setEditingUser2({ ...editingUser2, lastName });
                    }
                  }}
                  placeholder="Enter last name"
                  validate={(v) =>
                    validators.required(v, "Last Name") || validators.alpha(v)
                  }
                />
              </div>

              {/* Username with real-time validation */}
              <div className="form-group" style={{ gridColumn: "1 / -1" }}>
                <label className="required">Username</label>
                <UsernameField
                                  value={editingUser2.userName || ""}
                                  name="txtusername"
                  onChange={(v) =>
                    setEditingUser2({
                      ...editingUser2,
                      userName: v,
                      _usernameTouched: true,
                    })
                  }
                  allUsers={users}
                  currentUserId={editingUser2.id}
                />
              </div>

              <div className="form-group" style={{ gridColumn: "1 / -1" }}>
                <label className="required">Email</label>
                <ValidatedInput
                  required
                  type="email"
                  value={editingUser2.email}
                  onChange={(v) => {
                    updateField("email", v);
                    setEditingUser2({ ...editingUser2, email: v });
                  }}
                  validate={(v) =>
                    validators.required(v, "Email") || validators.email(v)
                  }
                  //onChange={(e) => setEditingUser({ ...editingUser, email: e.target.value })}
                  placeholder="user@organization.com"
                  //readOnly={!!editingUser.id /* usernames are immutable after creation */}
                />
              </div>

              {/* Password fields — only when ADDING a new user. Existing
            users change their password from the Profile page. */}
              {/*{!editingUser.id && (*/}
              <>
                {/* Password-action row: spans both columns */}
                <div
                  style={{
                    gridColumn: "1 / -1",
                    display: "flex",
                    gap: 8,
                    flexWrap: "wrap",
                    alignItems: "center",
                    marginBottom: -4,
                  }}
                >
                  <button
                    type="button"
                    onClick={async () => {
                      const pwd = generatePassword();
                      setEditingUser2({
                        ...editingUser2,
                        password: pwd,
                        confirmPassword: pwd,
                      });
                      setRevealPassword(true);
                      // Best-effort clipboard copy so the admin can share it securely.
                      try {
                        await navigator.clipboard?.writeText(pwd);
                        toast.success(
                          "Strong password generated and copied to clipboard. Share it with the user securely.",
                          { title: "Password generated" },
                        );
                      } catch {
                        toast.info(
                          "Strong password generated. Copy it manually before saving — it will not be shown again.",
                          { title: "Password generated" },
                        );
                      }
                    }}
                    style={{
                      padding: "8px 14px",
                      borderRadius: 10,
                      border: "1px solid rgba(13,148,136,0.3)",
                      background: "rgba(13,148,136,0.08)",
                      color: "#0D9488",
                      fontSize: 13,
                      fontWeight: 700,
                      cursor: "pointer",
                      fontFamily: "inherit",
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 6,
                    }}
                    title="Generate a strong random password (12+ chars, mixed case, digit, symbol)"
                  >
                    <Key size={13} strokeWidth={2.5} />
                    Generate Password
                  </button>
                  <button
                    type="button"
                    onClick={() => setRevealPassword((r) => !r)}
                    style={{
                      padding: "8px 12px",
                      borderRadius: 10,
                      border: "1px solid #E8ECF0",
                      background: "#fff",
                      color: "#6B7280",
                      fontSize: 13,
                      fontWeight: 600,
                      cursor: "pointer",
                      fontFamily: "inherit",
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 6,
                    }}
                    title={revealPassword ? "Hide password" : "Show password"}
                  >
                    {revealPassword ? (
                      <>
                        <EyeOff size={13} strokeWidth={2} /> Hide
                      </>
                    ) : (
                      <>
                        <Eye size={13} strokeWidth={2} /> Show
                      </>
                    )}
                  </button>
                  {editingUser2.password && (
                    <button
                      type="button"
                      onClick={async () => {
                        try {
                          await navigator.clipboard?.writeText(
                            editingUser2.password || "",
                          );
                          toast.success("Password copied to clipboard.", {
                            title: "Copied",
                          });
                        } catch {
                          toast.error(
                            "Could not copy — clipboard access denied.",
                            { title: "Copy failed" },
                          );
                        }
                      }}
                      style={{
                        padding: "8px 12px",
                        borderRadius: 10,
                        border: "1px solid #E8ECF0",
                        background: "#fff",
                        color: "#6B7280",
                        fontSize: 13,
                        fontWeight: 600,
                        cursor: "pointer",
                        fontFamily: "inherit",
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 6,
                      }}
                      title="Copy current password to clipboard"
                    >
                      <Copy size={13} strokeWidth={2} /> Copy
                    </button>
                  )}
                </div>

                <ValidatedInput
                  label="New Password"
                  required
                  type={revealPassword ? "text" : "password"}
                  value={editingUser2.password || ""}
                  onChange={(v) =>
                    setEditingUser2({ ...editingUser2, password: v })
                  }
                  validate={(v) => validators.password(v)}
                  placeholder="Enter a strong password"
                  helpText="Min 8 chars, uppercase, lowercase, number"
                  autoComplete="new-password"
                />
                <ValidatedInput
                  label="Confirm Password"
                  required
                  type={revealPassword ? "text" : "password"}
                  value={editingUser2.confirmPassword || ""}
                  onChange={(v) =>
                    setEditingUser2({ ...editingUser2, confirmPassword: v })
                  }
                  validate={(v) =>
                    v && v !== (editingUser2.password || "")
                      ? "Passwords do not match"
                      : null
                  }
                  placeholder="Re-enter the password"
                  autoComplete="new-password"
                />
              </>
              {/*)}*/}

              <div className="form-group">
                <label className="required">Phone</label>
                <ValidatedInput
                  required
                  type="tel"
                  onChange={(v) => {
                    updateField("phone", v);
                    setEditingUser2({ ...editingUser2, phone: v });
                  }}
                  validate={(v) =>
                    validators.required(v, "Phone") || validators.phone(v)
                  }
                  value={editingUser2.phone}

                  placeholder="(512) 555-0000"
                  format={formatters.phone}
                />
              </div>
              {/*<div className="form-group">*/}
              {/*    <label className="required">Role</label>*/}
              {/*    <select*/}
              {/*        value={editingUser.role}*/}
              {/*        onChange={(e) => setEditingUser({ ...editingUser, role: e.target.value })}*/}
              {/*    >*/}
              {/*        */}
              {/*<option value="Super Admin">Super Admin</option>*/}
              {/*        */}
              {/*<option value="Admin">Admin</option>*/}
              {/*        */}
              {/*<option value="Provider">Provider</option>*/}
              {/*        */}
              {/*<option value="Staff">Staff</option>*/}
              {/*        */}
              {/*<option value="Viewer">Viewer</option>*/}
              {/*        {roles.map((role) => (*/}
              {/*            <option key={role.Id} value={role.Name}>*/}
              {/*                {role.Name}*/}
              {/*            </option>*/}
              {/*        ))}*/}
              {/*    </select>*/}
              {/*</div>*/}
              <div className="form-group" style={{ gridColumn: "1 / -1" }}>
                <label>Status</label>
                <div style={{ display: "flex", gap: 10, marginTop: 4 }}>
                  {["Active", "Inactive"].map((s) => (
                    <label
                      key={s}
                      style={{
                        flex: 1,
                        display: "flex",
                        alignItems: "center",
                        gap: 10,
                        padding: "12px 14px",
                        borderRadius: 10,
                        cursor: "pointer",
                        border: `1.5px solid ${editingUser2.status === s ? "#0D9488" : "#E8ECF0"}`,
                        background:
                          editingUser2.status === s
                            ? "rgba(13,148,136,0.04)"
                            : "#fff",
                        transition: "all 0.15s",
                      }}
                    >
                      <input
                        type="radio"
                        name="status"
                        checked={editingUser2.status === s}
                        onChange={() =>
                          setEditingUser2({ ...editingUser2, status: s })
                        }
                        style={{ accentColor: "#0D9488" }}
                      />
                      <Circle
                        size={9}
                        strokeWidth={0}
                        fill={s === "Active" ? "#10B981" : "#9CA3AF"}
                      />
                      <span
                        style={{
                          fontSize: 13,
                          fontWeight: 600,
                          color: "#1A1D21",
                        }}
                      >
                        {s}
                      </span>
                    </label>
                  ))}
                </div>
              </div>

              {/* ============================================================
    ACCESS PERMISSIONS
============================================================ */}

              <div
                className="form-group"
                style={{
                  gridColumn: "1 / -1",
                  marginTop: 8,
                  paddingTop: 20,
                  borderTop: "1px solid #E8ECF0",
                }}
              >
                {/* --------------------------------------------------------
        Header
    -------------------------------------------------------- */}

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    gap: 12,
                    marginBottom: 14,
                  }}
                >
                  <div>
                    <div
                      style={{
                        fontSize: 15,
                        fontWeight: 700,
                        color: "#1A1D21",
                      }}
                    >
                      Access Permissions
                    </div>

                    <div
                      style={{
                        fontSize: 12,
                        color: "#6B7280",
                        marginTop: 4,
                      }}
                    >
                      Select the pages and functionality this user is allowed to
                      access.
                    </div>

                    {/* Permission count */}

                    {(() => {
                      const count = getPermissionCount(
                        editingUser2.permissions,
                      );

                      return (
                        <div
                          style={{
                            fontSize: 11,
                            color: "#0D9488",
                            fontWeight: 600,
                            marginTop: 6,
                          }}
                        >
                          {count.selected} of {count.total} permissions selected
                        </div>
                      );
                    })()}
                  </div>

                  {/* ----------------------------------------------------
            Select All / Clear All
        ---------------------------------------------------- */}

                  <div
                    style={{
                      display: "flex",
                      gap: 8,
                      flexShrink: 0,
                    }}
                  >
                    <button
                      type="button"
                      onClick={() => {
                        setEditingUser2((prev) => ({
                          ...prev,
                          permissions: createAllPermissions(),
                        }));
                      }}
                      style={{
                        padding: "6px 10px",
                        borderRadius: 7,
                        border: "1px solid rgba(13,148,136,0.25)",
                        background: "rgba(13,148,136,0.06)",
                        color: "#0D9488",
                        fontSize: 11,
                        fontWeight: 700,
                        cursor: "pointer",
                      }}
                    >
                      Select All
                    </button>

                    <button
                      type="button"
                      onClick={() => {
                        setEditingUser2((prev) => ({
                          ...prev,
                          permissions: createEmptyPermissions(),
                        }));
                      }}
                      style={{
                        padding: "6px 10px",
                        borderRadius: 7,
                        border: "1px solid #E8ECF0",
                        background: "#fff",
                        color: "#6B7280",
                        fontSize: 11,
                        fontWeight: 700,
                        cursor: "pointer",
                      }}
                    >
                      Clear All
                    </button>
                  </div>
                </div>

                {/* ========================================================
        PERMISSION CONTAINER
    ======================================================== */}

                <div
                  style={{
                    border: "1px solid #E8ECF0",
                    borderRadius: 10,
                    overflow: "hidden",
                    background: "#fff",
                  }}
                >
                  {PERMISSION_GROUPS.map((group, groupIndex) => {
                    /* ==================================================
                                         NORMAL APPLICATION PAGE
                                      ================================================== */

                    if (group.type === "page") {
                      const selectedCount = group.permissions.filter(
                        (permission) =>
                          editingUser2.permissions?.[group.key]?.[
                            permission.key
                          ] === true,
                      ).length;

                      const allSelected =
                        selectedCount === group.permissions.length;

                      const someSelected = selectedCount > 0 && !allSelected;

                      return (
                        <div
                          key={group.key}
                          style={{
                            padding: "15px 16px",
                            borderBottom:
                              groupIndex !== PERMISSION_GROUPS.length - 1
                                ? "1px solid #E8ECF0"
                                : "none",
                          }}
                        >
                          {/* Page Header */}

                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              marginBottom: 10,
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 9,
                              }}
                            >
                              <input
                                type="checkbox"
                                checked={allSelected}
                                ref={(element) => {
                                  if (element) {
                                    element.indeterminate = someSelected;
                                  }
                                }}
                                onChange={() => {
                                  setEditingUser2((prev) => ({
                                    ...prev,

                                    permissions: {
                                      ...prev.permissions,

                                      [group.key]: group.permissions.reduce(
                                        (result, permission) => {
                                          result[permission.key] = !allSelected;

                                          return result;
                                        },
                                        {},
                                      ),
                                    },
                                  }));
                                }}
                                style={{
                                  width: 15,
                                  height: 15,
                                  accentColor: "#0D9488",
                                  cursor: "pointer",
                                }}
                              />

                              <div>
                                <div
                                  style={{
                                    fontSize: 13,
                                    fontWeight: 700,
                                    color: "#1A1D21",
                                  }}
                                >
                                  {group.label}
                                </div>

                                <div
                                  style={{
                                    fontSize: 10,
                                    color: "#9CA3AF",
                                    marginTop: 2,
                                  }}
                                >
                                  {selectedCount} of {group.permissions.length}{" "}
                                  selected
                                </div>
                              </div>
                            </div>

                            <button
                              type="button"
                              onClick={() => {
                                setEditingUser2((prev) => ({
                                  ...prev,

                                  permissions: {
                                    ...prev.permissions,

                                    [group.key]: group.permissions.reduce(
                                      (result, permission) => {
                                        result[permission.key] = !allSelected;

                                        return result;
                                      },
                                      {},
                                    ),
                                  },
                                }));
                              }}
                              style={{
                                border: "none",
                                background: "transparent",
                                color: "#0D9488",
                                fontSize: 11,
                                fontWeight: 700,
                                cursor: "pointer",
                              }}
                            >
                              {allSelected ? "Clear All" : "Select All"}
                            </button>
                          </div>

                          {/* Page Actions */}

                          <div
                            style={{
                              display: "grid",
                              gridTemplateColumns:
                                "repeat(auto-fit, minmax(180px, 1fr))",
                              gap: 8,
                            }}
                          >
                            {group.permissions.map((permission) => {
                              const checked =
                                editingUser2.permissions?.[group.key]?.[
                                  permission.key
                                ] === true;

                              return (
                                <label
                                  key={permission.key}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 9,
                                    padding: "9px 10px",
                                    borderRadius: 8,
                                    border: `1px solid ${
                                      checked ? "#0D9488" : "#E8ECF0"
                                    }`,
                                    background: checked
                                      ? "rgba(13,148,136,0.05)"
                                      : "#fff",
                                    cursor: "pointer",
                                    transition: "all 0.15s",
                                  }}
                                >
                                  <input
                                    type="checkbox"
                                    checked={checked}
                                    onChange={(e) => {
                                      const value = e.target.checked;

                                      setEditingUser2((prev) => ({
                                        ...prev,

                                        permissions: {
                                          ...prev.permissions,

                                          [group.key]: {
                                            ...prev.permissions?.[group.key],

                                            [permission.key]: value,
                                          },
                                        },
                                      }));
                                    }}
                                    style={{
                                      width: 15,
                                      height: 15,
                                      accentColor: "#0D9488",
                                      cursor: "pointer",
                                    }}
                                  />

                                  <span
                                    style={{
                                      fontSize: 12,
                                      fontWeight: 600,
                                      color: checked ? "#0D766D" : "#374151",
                                    }}
                                  >
                                    {permission.label}
                                  </span>
                                </label>
                              );
                            })}
                          </div>
                        </div>
                      );
                    }

                    /* ==================================================
                                         SECTION - SUPER ADMIN
                                      ================================================== */

                    if (group.type === "section") {
                      return (
                        <div
                          key={group.key}
                          style={{
                            padding: "0",
                            borderBottom:
                              groupIndex !== PERMISSION_GROUPS.length - 1
                                ? "1px solid #E8ECF0"
                                : "none",
                          }}
                        >
                          {/* =================================================
                            SECTION HEADER
                        ================================================= */}

                          <div
                            style={{
                              padding: "16px 16px 12px",
                              background:
                                "linear-gradient(180deg, #F8FAFC 0%, #F4F7F8 100%)",
                              borderBottom: "1px solid #E8ECF0",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 10,
                                }}
                              >
                                <div
                                  style={{
                                    width: 32,
                                    height: 32,
                                    borderRadius: 8,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    background: "rgba(13,148,136,0.10)",
                                    color: "#0D9488",
                                    fontSize: 14,
                                    fontWeight: 800,
                                  }}
                                >
                                  SA
                                </div>

                                <div>
                                  <div
                                    style={{
                                      fontSize: 14,
                                      fontWeight: 800,
                                      color: "#1A1D21",
                                    }}
                                  >
                                    {group.label}
                                  </div>

                                  <div
                                    style={{
                                      fontSize: 11,
                                      color: "#6B7280",
                                      marginTop: 2,
                                    }}
                                  >
                                    Administrative pages and functionality
                                  </div>
                                </div>
                              </div>

                              {/* Select entire Super Admin */}

                              <button
                                type="button"
                                onClick={() => {
                                  const allChildrenSelected =
                                    group.children.every((child) =>
                                      child.permissions.every(
                                        (permission) =>
                                          editingUser2.permissions?.[
                                            group.key
                                          ]?.[child.key]?.[permission.key] ===
                                          true,
                                      ),
                                    );

                                  setEditingUser2((prev) => ({
                                    ...prev,

                                    permissions: {
                                      ...prev.permissions,

                                      [group.key]: group.children.reduce(
                                        (result, child) => {
                                          result[child.key] =
                                            child.permissions.reduce(
                                              (childResult, permission) => {
                                                childResult[permission.key] =
                                                  !allChildrenSelected;

                                                return childResult;
                                              },
                                              {},
                                            );

                                          return result;
                                        },
                                        {},
                                      ),
                                    },
                                  }));
                                }}
                                style={{
                                  padding: "6px 10px",
                                  borderRadius: 7,
                                  border: "1px solid rgba(13,148,136,0.25)",
                                  background: "rgba(13,148,136,0.06)",
                                  color: "#0D9488",
                                  fontSize: 11,
                                  fontWeight: 700,
                                  cursor: "pointer",
                                }}
                              >
                                Select All
                              </button>
                            </div>
                          </div>

                          {/* =================================================
                            SUPER ADMIN CHILDREN
                        ================================================= */}

                          {group.children.map((child, childIndex) => {
                            const selectedCount = child.permissions.filter(
                              (permission) =>
                                editingUser2.permissions?.[group.key]?.[
                                  child.key
                                ]?.[permission.key] === true,
                            ).length;

                            const allSelected =
                              selectedCount === child.permissions.length;

                            const someSelected =
                              selectedCount > 0 && !allSelected;

                            return (
                              <div
                                key={child.key}
                                style={{
                                  padding: "15px 16px",
                                  borderBottom:
                                    childIndex !== group.children.length - 1
                                      ? "1px solid #F0F2F4"
                                      : "none",
                                }}
                              >
                                {/* Child Header */}

                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    marginBottom: 10,
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 9,
                                    }}
                                  >
                                    <input
                                      type="checkbox"
                                      checked={allSelected}
                                      ref={(element) => {
                                        if (element) {
                                          element.indeterminate = someSelected;
                                        }
                                      }}
                                      onChange={() => {
                                        setEditingUser2((prev) => ({
                                          ...prev,

                                          permissions: {
                                            ...prev.permissions,

                                            [group.key]: {
                                              ...prev.permissions?.[group.key],

                                              [child.key]:
                                                child.permissions.reduce(
                                                  (result, permission) => {
                                                    result[permission.key] =
                                                      !allSelected;

                                                    return result;
                                                  },
                                                  {},
                                                ),
                                            },
                                          },
                                        }));
                                      }}
                                      style={{
                                        width: 15,
                                        height: 15,
                                        accentColor: "#0D9488",
                                        cursor: "pointer",
                                      }}
                                    />

                                    <div>
                                      <div
                                        style={{
                                          fontSize: 13,
                                          fontWeight: 700,
                                          color: "#1A1D21",
                                        }}
                                      >
                                        {child.label}
                                      </div>

                                      <div
                                        style={{
                                          fontSize: 10,
                                          color: "#9CA3AF",
                                          marginTop: 2,
                                        }}
                                      >
                                        {selectedCount} of{" "}
                                        {child.permissions.length} selected
                                      </div>
                                    </div>
                                  </div>

                                  <button
                                    type="button"
                                    onClick={() => {
                                      setEditingUser2((prev) => ({
                                        ...prev,

                                        permissions: {
                                          ...prev.permissions,

                                          [group.key]: {
                                            ...prev.permissions?.[group.key],

                                            [child.key]:
                                              child.permissions.reduce(
                                                (result, permission) => {
                                                  result[permission.key] =
                                                    !allSelected;

                                                  return result;
                                                },
                                                {},
                                              ),
                                          },
                                        },
                                      }));
                                    }}
                                    style={{
                                      border: "none",
                                      background: "transparent",
                                      color: "#0D9488",
                                      fontSize: 11,
                                      fontWeight: 700,
                                      cursor: "pointer",
                                    }}
                                  >
                                    {allSelected ? "Clear All" : "Select All"}
                                  </button>
                                </div>

                                {/* Child Permissions */}

                                <div
                                  style={{
                                    display: "grid",
                                    gridTemplateColumns:
                                      "repeat(auto-fit, minmax(180px, 1fr))",
                                    gap: 8,
                                  }}
                                >
                                  {child.permissions.map((permission) => {
                                    const checked =
                                      editingUser2.permissions?.[group.key]?.[
                                        child.key
                                      ]?.[permission.key] === true;

                                    return (
                                      <label
                                        key={`${group.key}-${child.key}-${permission.key}`}
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: 9,
                                          padding: "9px 10px",
                                          borderRadius: 8,
                                          border: `1px solid ${
                                            checked ? "#0D9488" : "#E8ECF0"
                                          }`,
                                          background: checked
                                            ? "rgba(13,148,136,0.05)"
                                            : "#fff",
                                          cursor: "pointer",
                                          transition: "all 0.15s",
                                        }}
                                      >
                                        <input
                                          type="checkbox"
                                          checked={checked}
                                          onChange={(e) => {
                                            const value = e.target.checked;

                                            setEditingUser2((prev) => ({
                                              ...prev,

                                              permissions: {
                                                ...prev.permissions,

                                                [group.key]: {
                                                  ...prev.permissions?.[
                                                    group.key
                                                  ],

                                                  [child.key]: {
                                                    ...prev.permissions?.[
                                                      group.key
                                                    ]?.[child.key],

                                                    [permission.key]: value,
                                                  },
                                                },
                                              },
                                            }));
                                          }}
                                          style={{
                                            width: 15,
                                            height: 15,
                                            accentColor: "#0D9488",
                                            cursor: "pointer",
                                          }}
                                        />

                                        <span
                                          style={{
                                            fontSize: 12,
                                            fontWeight: 600,
                                            color: checked
                                              ? "#0D766D"
                                              : "#374151",
                                          }}
                                        >
                                          {permission.label}
                                        </span>
                                      </label>
                                    );
                                  })}
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      );
                    }

                    return null;
                  })}
                </div>
              </div>
            </div>
          </div>
          <DialogActionsBar>
                      <Button name="btnCloseAddAdminUserDialog" onClick={closeDialog}>Cancel</Button>
            <Button
              themeColor="primary"
              name="btnSave"
                          onClick={handleSave}
             
              //   disabled={
              //     saving ||
              //      (!editingUser2.id && !validateUsername(editingUser2.userName, users, editingUser2.id).valid) ||
              //    (!editingUser2.id && (
              //      validators.password(editingUser2.password || '') !== null ||
              //      (editingUser2.password || '') !== (editingUser2.confirmPassword || '')
              //   ))
              // }
              disabled={saving || !isUserFormValid()}
            >
              {saving
                ? "Saving..."
                : editingUser2.id
                  ? "Save Changes"
                  : "Add User"}
            </Button>
          </DialogActionsBar>
        </Dialog>
      )}

      {/* ── Delete Confirmation Dialog ──────────────── */}
      {deleteTarget && (
        <Dialog
          title="Delete User"
          onClose={() => setDeleteTarget(null)}
          /*width={480}*/
          width={viewportWidth < 640 ? Math.max(viewportWidth - 24, 300) : 560}
        >
          <div
            style={{
              padding: "12px 4px 4px",
              display: "flex",
              gap: 14,
              alignItems: "flex-start",
            }}
          >
            <div
              style={{
                width: 44,
                height: 44,
                borderRadius: 12,
                background: "rgba(239,68,68,0.1)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              <AlertTriangle size={22} color="#DC2626" strokeWidth={2} />
            </div>
            <div style={{ flex: 1 }}>
              <div
                style={{
                  fontSize: 15,
                  fontWeight: 700,
                  color: "#1A1D21",
                  marginBottom: 6,
                }}
              >
                Delete {deleteTarget.firstName} {deleteTarget.lastName}?
              </div>
              <div
                style={{
                  fontSize: 13,
                  color: "#6B7280",
                  lineHeight: 1.6,
                  marginBottom: 12,
                }}
              >
                This will permanently remove the user from{" "}
                <strong style={{ color: "#1A1D21" }}>
                  {deleteTarget.orgName}
                </strong>{" "}
                and the Central Health network. They will lose all portal access
                immediately.
              </div>
              <div
                style={{
                  padding: "10px 12px",
                  borderRadius: 10,
                  background: "rgba(239,68,68,0.06)",
                  border: "1px solid rgba(239,68,68,0.15)",
                  fontSize: 12,
                  color: "#991B1B",
                }}
              >
                <strong>This action cannot be undone.</strong>
              </div>
            </div>
          </div>
          <DialogActionsBar>
            <Button onClick={() => setDeleteTarget(null)}>Cancel</Button>
            <Button
              themeColor="error"
              onClick={handleConfirmDelete}
              disabled={deleting}
            >
              {deleting ? "Deleting..." : "Delete User"}
            </Button>
          </DialogActionsBar>
        </Dialog>
      )}

      {/* ── Sign-in Activity Viewer (Super Admin) ──── */}
      {activityUser && (
        <Dialog
          title={`Sign-in Activity — ${activityUser.firstName} ${activityUser.lastName}`}
          onClose={() => setActivityUser(null)}
          /*width={840}*/
          width={viewportWidth < 640 ? Math.max(viewportWidth - 24, 300) : 560}
        >
          <div style={{ padding: "4px 0" }}>
            <div
              style={{
                padding: "10px 14px",
                borderRadius: 10,
                background: "rgba(220,38,38,0.05)",
                border: "1px solid rgba(220,38,38,0.15)",
                marginBottom: 14,
                fontSize: 12,
                color: "#991B1B",
                display: "flex",
                alignItems: "center",
                gap: 8,
              }}
            >
              <ShieldCheck size={14} strokeWidth={2} />
              <span>
                <strong>Audit view.</strong> You're viewing{" "}
                {activityUser.firstName}'s sign-in history as a Super Admin. All
                access to this data is itself logged.
              </span>
            </div>
            <LoginActivityCard
              userId={activityUser.id}
              title={`${activityUser.orgName} · ${activityUser.role}`}
              canClear={false}
              adminView
            />
          </div>
          <DialogActionsBar>
            <Button onClick={() => setActivityUser(null)}>Close</Button>
          </DialogActionsBar>
        </Dialog>
      )}
    </div>
  );
};

const EmptyState = ({ hasFilters }) => (
  <div className="card" style={{ textAlign: "center", padding: "56px 24px" }}>
    <div
      style={{
        width: 64,
        height: 64,
        borderRadius: 16,
        background: "rgba(13,148,136,0.08)",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        marginBottom: 16,
      }}
    >
      {hasFilters ? (
        <Search size={28} color="#0D9488" strokeWidth={2} />
      ) : (
        <Users size={28} color="#0D9488" strokeWidth={2} />
      )}
    </div>
    <div
      style={{
        fontSize: 17,
        fontWeight: 700,
        color: "#1A1D21",
        marginBottom: 6,
      }}
    >
      {hasFilters ? "No users match your filters" : "No users in the system"}
    </div>
    <div style={{ fontSize: 13, color: "#6B7280" }}>
      {hasFilters
        ? "Try clearing the filters or adjusting the search."
        : "System users will appear here as organizations are onboarded."}
    </div>
  </div>
);

const selectStyle = {
  padding: "8px 12px",
  borderRadius: 10,
  border: "1.5px solid #E8ECF0",
  fontSize: 13,
  fontWeight: 600,
  color: "#374151",
  background: "#F8FAFB",
  cursor: "pointer",
  fontFamily: "inherit",
  outline: "none",
};

const toggleBtnStyle = (active) => ({
  padding: "7px 12px",
  borderRadius: 8,
  border: "none",
  background: active ? "#fff" : "transparent",
  color: active ? "#0D9488" : "#6B7280",
  fontSize: 12,
  fontWeight: 700,
  cursor: "pointer",
  display: "inline-flex",
  alignItems: "center",
  gap: 5,
  boxShadow: active ? "0 1px 3px rgba(0,0,0,0.08)" : "none",
  fontFamily: "inherit",
  transition: "all 0.15s",
});

export default SystemUsersPage;
